// AUTO-GENERATED by backend/scripts/gen_translations.py — page-chrome strings.
export const PAGE_STRINGS = {
  "de": {
    "cp_kw_label": "Flughafentransfer",
    "cp_eyebrow": "Flughafentransfer Zürich",
    "cp_taxi_limo": "Taxi & Limousine",
    "cp_b1": "Festpreis",
    "cp_b2": "Flugverfolgung 24/7",
    "cp_b3": "Lizenzierte Fahrer",
    "cp_calc_price": "Preis berechnen",
    "cp_f1_t": "Feste Preise",
    "cp_f1_d": "Ihr Preis steht vor der Fahrt fest – keine Überraschungen.",
    "cp_f2_t": "Immer pünktlich",
    "cp_f2_d": "Wir überwachen Ihren Flug und passen uns an.",
    "cp_f3_t": "Sicher & lizenziert",
    "cp_f3_d": "Geschulte Schweizer Chauffeure, gepflegte Fahrzeuge.",
    "cp_vehicles_for": "Fahrzeuge für {city}",
    "cp_seats": "Sitze",
    "cp_guide_loading": "Ausführlicher Reiseführer für {city} wird geladen…",
    "cp_guide_na": "Reiseführer derzeit nicht verfügbar. Buchen Sie jetzt Ihren Transfer nach {city}.",
    "cp_more_dest": "Weitere Destinationen",
    "cp_all_places": "Alle Orte",
    "cp_seo_title": "Flughafentransfer & Taxi {city}",
    "cp_seo_desc": "Premium Flughafentransfer, Taxi & Chauffeurservice in {city}. Festpreise ab Flughafen Zürich (ZRH), professionelle Fahrer und Flugverfolgung rund um die Uhr.",
    "cp_prices_for": "Preise für Flughafentransfer nach {city}",
    "cp_prices_note": "Festpreise pro Fahrzeugklasse (Richtwert ab Flughafen Zürich, inkl. Steuern).",
    "cp_ready_transfer": "Bereit für Ihren Transfer nach {city}?",
    "cp_fixed_sec": "Festpreis in Sekunden – ganz ohne Konto.",
    "cp_book_now": "Jetzt buchen",
    "bp_step_route": "Route",
    "bp_step_vehicle": "Fahrzeug",
    "bp_step_details": "Details",
    "bp_step_confirm": "Bestätigung",
    "bp_title": "Transfer buchen",
    "bp_subtitle": "Festpreis in Sekunden — professionelle Chauffeure in der ganzen Schweiz.",
    "bp_pickup": "Abholadresse",
    "bp_pickup_ph": "Adresse, Flughafen, Hotel…",
    "bp_dropoff": "Zieladresse",
    "bp_dropoff_ph": "Zieladresse…",
    "bp_duration": "Dauer",
    "bp_hours_unit": "{n} Stunden",
    "bp_date": "Datum",
    "bp_date_ph": "Datum wählen",
    "bp_time": "Uhrzeit",
    "bp_time_ph": "Zeit",
    "bp_see_prices": "Preise ansehen",
    "bp_copy_share": "Link kopieren & teilen",
    "bp_share_wa": "Per WhatsApp teilen",
    "bp_copy_link": "Link kopieren",
    "bp_link_copied": "Link kopiert",
    "bp_link_copied_d": "Route, Datum & Uhrzeit sind im Link gespeichert.",
    "bp_copy_fail": "Kopieren fehlgeschlagen",
    "bp_fill_all": "Bitte alle Felder ausfüllen",
    "bp_fill_all_d": "Adresse, Datum und Uhrzeit werden benötigt.",
    "bp_error": "Fehler",
    "bp_route_error": "Route konnte nicht berechnet werden.",
    "bp_fill_contact": "Bitte Kontaktdaten ausfüllen",
    "bp_booking_failed": "Buchung fehlgeschlagen.",
    "bp_your_ride": "Ihre Fahrt",
    "bp_gratis": "(gratis)",
    "bp_total": "Gesamt",
    "bp_incl": "inkl. MwSt., Wartezeit & Flugverfolgung",
    "bp_fixed": "Festpreis",
    "bp_select_next": "Auswählen & weiter",
    "bp_back": "Zurück",
    "bp_passenger_data": "Passagierdaten",
    "bp_save_details": "Meine Daten für das nächste Mal speichern",
    "bp_passengers": "Passagiere",
    "bp_luggage": "Gepäck",
    "bp_childseats": "Kindersitze",
    "bp_childseats_note": "1. Sitz gratis · jeder weitere CHF 10",
    "bp_child": "Kind",
    "bp_seat_baby": "Babyschale · 0–1 Jahr",
    "bp_seat_child": "Kindersitz · 1–6 Jahre",
    "bp_seat_boost": "Sitzerhöhung · 6–12 Jahre",
    "bp_free": "gratis",
    "bp_first_name": "Vorname",
    "bp_last_name": "Nachname",
    "bp_email": "E-Mail",
    "bp_phone": "Telefon",
    "bp_flight_opt": "Flugnummer (optional)",
    "bp_notes_opt": "Hinweise (optional)",
    "bp_payment": "Zahlungsart",
    "bp_card": "Kreditkarte",
    "bp_card_sub": "Online bezahlen",
    "bp_cash": "Barzahlung",
    "bp_cash_sub": "Im Fahrzeug",
    "bp_secure_card": "Sichere Online-Zahlung per Kreditkarte (SumUp).",
    "bp_secure_cash": "Ihre Anfrage wird geprüft und per E-Mail bestätigt.",
    "bp_pay_now": "Jetzt online bezahlen",
    "bp_send_request": "Anfrage senden",
    "bp_card_details": "Kartendaten eingeben",
    "bp_verifying": "Zahlung wird überprüft …",
    "bp_pay_pending": "Zahlung noch nicht abgeschlossen. Bitte versuchen Sie es erneut.",
    "bp_pay_failed": "Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "bp_received": "Anfrage erhalten!",
    "bp_received_1": "Ihre Buchungsanfrage",
    "bp_received_2": "wurde übermittelt. Wir prüfen die Verfügbarkeit und senden Ihnen umgehend eine Bestätigung per E-Mail.",
    "bp_vehicle": "Fahrzeug",
    "bp_price": "Preis",
    "bp_card_conf": "Kreditkarte (Zahlungslink folgt per E-Mail)",
    "bp_cash_conf": "Barzahlung im Fahrzeug",
    "bp_back_home": "Zurück zur Startseite",
    "bl_eyebrow": "Blog",
    "bl_title": "Ratgeber, Reiseziele & Transfers",
    "bl_sub": "Praktische Ratgeber zu allen unseren Services und ein Flughafentransfer-Guide für über 400 Orte in der Schweiz.",
    "bl_cat_flughafen": "Flughafentransfer",
    "bl_cat_flughafen_d": "Vom & zum Flughafen Zürich zum Festpreis.",
    "bl_cat_city": "Stadt zu Stadt",
    "bl_cat_city_d": "Direkt zwischen Schweizer Städten.",
    "bl_cat_hourly": "Stundenbuchung",
    "bl_cat_hourly_d": "Ihr Chauffeur für den ganzen Tag.",
    "bl_cat_biz": "Geschäftlich",
    "bl_cat_biz_d": "Diskrete Mobilität für Unternehmen.",
    "bl_learn_more": "Mehr erfahren",
    "bl_read_more": "Weiterlesen",
    "bl_read_time": "Lesezeit",
    "bl_dir_title": "Flughafentransfer nach Ort",
    "bl_dir_sub": "Über {n} Orte in der Schweiz – jeder mit eigenem Reiseführer. Suchen Sie Ihren Zielort.",
    "bl_search_ph": "Ort suchen, z. B. Bern, Interlaken…",
    "bl_no_city": "Kein Ort gefunden.",
    "ci_eyebrow": "Destinationen",
    "ci_title": "Transfers in der ganzen Schweiz",
    "ci_sub": "Von jedem Flughafen zu jeder Stadt und jedem Bergdorf. Wählen Sie Ihre Destination oder buchen Sie direkt.",
    "ci_popular": "Beliebte Orte",
    "pp_eyebrow": "Preise",
    "pp_title": "Transparente Festpreise",
    "pp_sub": "Jede Fahrt zu einem festen Preis: ein Grundpreis pro Fahrzeugklasse plus ein Kilometerpreis. Beispiel Economy: ab CHF 70, danach CHF 2.20/km. Keine versteckten Kosten.",
    "pp_f1_t": "Festpreis garantiert",
    "pp_f1_d": "Preis bei Buchung fixiert.",
    "pp_f2_t": "Flugverfolgung",
    "pp_f2_d": "Kostenlose Wartezeit bei Verspätung.",
    "pp_f3_t": "Inklusive",
    "pp_f3_d": "Steuern, Maut & Meet-&-Greet inklusive.",
    "pp_classes": "Unsere Fahrzeugklassen & Preise",
    "pp_book": "Buchen",
    "pp_dir_title": "Preise nach Zielort",
    "pp_dir_sub": "Über {n} Orte in der Schweiz und den Nachbarländern. Wählen Sie Ihren Zielort für den Festpreis-Reiseführer.",
    "pp_from": "ab",
    "ct_eyebrow": "Kontakt",
    "ct_title": "Wir sind für Sie da",
    "ct_sub": "Fragen zu Ihrer Fahrt oder Sonderwünsche? Kontaktieren Sie uns rund um die Uhr — telefonisch, per WhatsApp oder E-Mail.",
    "ct_phone": "Telefon",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "E-Mail",
    "ct_address": "Adresse",
    "ct_name": "Name",
    "ct_message": "Nachricht",
    "ct_send": "Nachricht senden",
    "ct_required": "Bitte alle Pflichtfelder ausfüllen",
    "ct_sent": "Nachricht gesendet",
    "ct_sent_d": "Wir melden uns so schnell wie möglich.",
    "ct_fail": "Nachricht konnte nicht gesendet werden.",
    "ba_back": "Zurück zum Blog",
    "ba_transfer_to": "Flughafentransfer nach {city}",
    "ba_guide_creating": "Reiseführer für {city} wird erstellt…",
    "ba_guide_creating_note": "Dies kann beim ersten Aufruf bis zu einer Minute dauern.",
    "ba_book_now_transfer": "Buchen Sie jetzt Ihren Transfer nach {city}.",
    "ba_ready_generic": "Bereit für Ihren Transfer?",
    "ba_not_found": "Artikel nicht gefunden",
    "ba_to_blog": "Zum Blog",
    "ba_more_articles": "Weitere Artikel",
    "hero_eyebrow": "Flughafen Zürich · Zuerich Airport Taxi",
    "hero_book_wa": "Per WhatsApp buchen",
    "hero_trust_sub": "Beliebt bei Reisenden am Flughafen Zürich",
    "ft_desc": "Premium Chauffeur- und Flughafentransferservice in der ganzen Schweiz.",
    "ft_services": "Leistungen",
    "ft_company": "Unternehmen",
    "ft_popular": "Beliebte Orte",
    "ft_svc_flughafen": "Flughafentransfer",
    "ft_svc_city": "Stadt zu Stadt",
    "ft_svc_hourly": "Stundenbuchung",
    "ft_svc_biz": "Geschäftsreisen",
    "ft_fleet": "Unsere Flotte",
    "ft_dest": "Reiseziele",
    "ft_blog": "Blog",
    "ft_contact": "Kontakt",
    "ft_rights": "Alle Rechte vorbehalten.",
    "ft_legal": "Datenschutz · AGB · Impressum",
    "dest_learn_more": "Mehr erfahren"
  },
  "en": {
    "cp_kw_label": "Airport Transfer",
    "cp_eyebrow": "Airport Transfer Zürich",
    "cp_taxi_limo": "Taxi & Limousine",
    "cp_b1": "Fixed Price",
    "cp_b2": "Flight Tracking 24/7",
    "cp_b3": "Licensed Drivers",
    "cp_calc_price": "Calculate Price",
    "cp_f1_t": "Fixed Prices",
    "cp_f1_d": "Your price is set before the ride – no surprises.",
    "cp_f2_t": "Always On Time",
    "cp_f2_d": "We monitor your flight and adjust accordingly.",
    "cp_f3_t": "Safe & Licensed",
    "cp_f3_d": "Trained Swiss chauffeurs, well-maintained vehicles.",
    "cp_vehicles_for": "Vehicles for {city}",
    "cp_seats": "Seats",
    "cp_guide_loading": "Detailed guide for {city} is loading…",
    "cp_guide_na": "Guide currently not available. Book your transfer to {city} now.",
    "cp_more_dest": "More Destinations",
    "cp_all_places": "All Places",
    "cp_seo_title": "Airport Transfer & Taxi {city}",
    "cp_seo_desc": "Premium Airport Transfer, Taxi & Chauffeur Service in {city}. Fixed prices from Zürich Airport (ZRH), professional drivers and flight tracking around the clock.",
    "cp_prices_for": "Prices for Airport Transfer to {city}",
    "cp_prices_note": "Fixed prices per vehicle class (indicative from Zürich Airport, incl. taxes).",
    "cp_ready_transfer": "Ready for your transfer to {city}?",
    "cp_fixed_sec": "Fixed price in seconds – without an account.",
    "cp_book_now": "Book Now",
    "bp_step_route": "Route",
    "bp_step_vehicle": "Vehicle",
    "bp_step_details": "Details",
    "bp_step_confirm": "Confirmation",
    "bp_title": "Book Transfer",
    "bp_subtitle": "Fixed price in seconds — professional chauffeurs across Switzerland.",
    "bp_pickup": "Pickup Address",
    "bp_pickup_ph": "Address, airport, hotel…",
    "bp_dropoff": "Dropoff Address",
    "bp_dropoff_ph": "Destination address…",
    "bp_duration": "Duration",
    "bp_hours_unit": "{n} Hours",
    "bp_date": "Date",
    "bp_date_ph": "Select Date",
    "bp_time": "Time",
    "bp_time_ph": "Time",
    "bp_see_prices": "View Prices",
    "bp_copy_share": "Copy & Share Link",
    "bp_share_wa": "Share via WhatsApp",
    "bp_copy_link": "Copy Link",
    "bp_link_copied": "Link Copied",
    "bp_link_copied_d": "Route, date & time are saved in the link.",
    "bp_copy_fail": "Copy failed",
    "bp_fill_all": "Please fill in all fields",
    "bp_fill_all_d": "Address, date and time are required.",
    "bp_error": "Error",
    "bp_route_error": "Route could not be calculated.",
    "bp_fill_contact": "Please fill in contact details",
    "bp_booking_failed": "Booking failed.",
    "bp_your_ride": "Your Ride",
    "bp_gratis": "(free)",
    "bp_total": "Total",
    "bp_incl": "incl. VAT, waiting time & flight tracking",
    "bp_fixed": "Fixed Price",
    "bp_select_next": "Select & Continue",
    "bp_back": "Back",
    "bp_passenger_data": "Passenger Data",
    "bp_save_details": "Save my details for next time",
    "bp_passengers": "Passengers",
    "bp_luggage": "Luggage",
    "bp_childseats": "Child Seats",
    "bp_childseats_note": "1st seat free · each additional CHF 10",
    "bp_child": "Child",
    "bp_seat_baby": "Baby Seat · 0–1 year",
    "bp_seat_child": "Child Seat · 1–6 years",
    "bp_seat_boost": "Booster Seat · 6–12 years",
    "bp_free": "free",
    "bp_first_name": "First Name",
    "bp_last_name": "Last Name",
    "bp_email": "E-Mail",
    "bp_phone": "Phone",
    "bp_flight_opt": "Flight Number (optional)",
    "bp_notes_opt": "Notes (optional)",
    "bp_payment": "Payment Method",
    "bp_card": "Credit Card",
    "bp_card_sub": "Pay Online",
    "bp_cash": "Cash Payment",
    "bp_cash_sub": "In the Vehicle",
    "bp_secure_card": "Secure online payment by credit card (SumUp).",
    "bp_secure_cash": "Your request will be checked and confirmed via email.",
    "bp_pay_now": "Pay Online Now",
    "bp_send_request": "Send Request",
    "bp_card_details": "Enter card details",
    "bp_verifying": "Verifying payment …",
    "bp_pay_pending": "Payment not completed yet. Please try again.",
    "bp_pay_failed": "Payment failed. Please try again.",
    "bp_received": "Request Received!",
    "bp_received_1": "Your booking request",
    "bp_received_2": "has been submitted. We will check availability and send you a confirmation via email shortly.",
    "bp_vehicle": "Vehicle",
    "bp_price": "Price",
    "bp_card_conf": "Credit Card (payment link will follow via email)",
    "bp_cash_conf": "Cash payment in the vehicle",
    "bp_back_home": "Back to Homepage",
    "bl_eyebrow": "Blog",
    "bl_title": "Guides, Destinations & Transfers",
    "bl_sub": "Practical guides for all our services and an airport transfer guide for over 400 locations in Switzerland.",
    "bl_cat_flughafen": "Airport Transfer",
    "bl_cat_flughafen_d": "From & to Zürich Airport at a fixed price.",
    "bl_cat_city": "City to City",
    "bl_cat_city_d": "Directly between Swiss cities.",
    "bl_cat_hourly": "Hourly Booking",
    "bl_cat_hourly_d": "Your chauffeur for the whole day.",
    "bl_cat_biz": "Business",
    "bl_cat_biz_d": "Discreet mobility for companies.",
    "bl_learn_more": "Learn More",
    "bl_read_more": "Read More",
    "bl_read_time": "Reading Time",
    "bl_dir_title": "Airport Transfer to Place",
    "bl_dir_sub": "Over {n} places in Switzerland – each with its own guide. Search for your destination.",
    "bl_search_ph": "Search place, e.g. Bern, Interlaken…",
    "bl_no_city": "No place found.",
    "ci_eyebrow": "Destinations",
    "ci_title": "Transfers across Switzerland",
    "ci_sub": "From any airport to any city and mountain village. Choose your destination or book directly.",
    "ci_popular": "Popular Locations",
    "pp_eyebrow": "Prices",
    "pp_title": "Transparent Fixed Prices",
    "pp_sub": "Every ride at a fixed price: a base price per vehicle class plus a per kilometer price. Example Economy: from CHF 70, then CHF 2.20/km. No hidden fees.",
    "pp_f1_t": "Fixed Price Guaranteed",
    "pp_f1_d": "Price fixed at booking.",
    "pp_f2_t": "Flight Tracking",
    "pp_f2_d": "Free waiting time for delays.",
    "pp_f3_t": "Included",
    "pp_f3_d": "Taxes, tolls & meet-and-greet included.",
    "pp_classes": "Our Vehicle Classes & Prices",
    "pp_book": "Book",
    "pp_dir_title": "Prices by Destination",
    "pp_dir_sub": "Over {n} places in Switzerland and neighboring countries. Choose your destination for the fixed price guide.",
    "pp_from": "from",
    "ct_eyebrow": "Contact",
    "ct_title": "We Are Here for You",
    "ct_sub": "Questions about your ride or special requests? Contact us 24/7 — by phone, via WhatsApp or email.",
    "ct_phone": "Phone",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "E-Mail",
    "ct_address": "Address",
    "ct_name": "Name",
    "ct_message": "Message",
    "ct_send": "Send Message",
    "ct_required": "Please fill in all required fields",
    "ct_sent": "Message sent",
    "ct_sent_d": "We will get back to you as soon as possible.",
    "ct_fail": "Message could not be sent.",
    "ba_back": "Back to Blog",
    "ba_transfer_to": "Airport Transfer to {city}",
    "ba_guide_creating": "Guide for {city} is being created…",
    "ba_guide_creating_note": "This may take up to a minute on the first access.",
    "ba_book_now_transfer": "Book your transfer to {city} now.",
    "ba_ready_generic": "Ready for your transfer?",
    "ba_not_found": "Item not found",
    "ba_to_blog": "To Blog",
    "ba_more_articles": "More Articles",
    "hero_eyebrow": "Zürich Airport · Swiss Chauffeur Service",
    "hero_book_wa": "Book via WhatsApp",
    "hero_trust_sub": "Popular with travelers at Zürich Airport",
    "ft_desc": "Premium chauffeur and airport transfer service across Switzerland.",
    "ft_services": "Services",
    "ft_company": "Company",
    "ft_popular": "Popular Locations",
    "ft_svc_flughafen": "Airport Transfer",
    "ft_svc_city": "City to City",
    "ft_svc_hourly": "Hourly Booking",
    "ft_svc_biz": "Business Travel",
    "ft_fleet": "Our Fleet",
    "ft_dest": "Destinations",
    "ft_blog": "Blog",
    "ft_contact": "Contact",
    "ft_rights": "All rights reserved.",
    "ft_legal": "Privacy Policy · Terms & Conditions · Imprint",
    "dest_learn_more": "Learn More"
  },
  "fr": {
    "cp_kw_label": "Transfert aéroport",
    "cp_eyebrow": "Transfert aéroport Zürich",
    "cp_taxi_limo": "Taxi & Limousine",
    "cp_b1": "Prix fixe",
    "cp_b2": "Suivi de vol 24/7",
    "cp_b3": "Chauffeurs licenciés",
    "cp_calc_price": "Calculer le prix",
    "cp_f1_t": "Prix fixes",
    "cp_f1_d": "Votre prix est déterminé avant la course – pas de surprises.",
    "cp_f2_t": "Toujours à l'heure",
    "cp_f2_d": "Nous surveillons votre vol et nous nous adaptons.",
    "cp_f3_t": "Sûr & licencié",
    "cp_f3_d": "Chauffeurs suisses formés, véhicules entretenus.",
    "cp_vehicles_for": "Véhicules pour {city}",
    "cp_seats": "Sièges",
    "cp_guide_loading": "Guide de voyage détaillé pour {city} en cours de chargement…",
    "cp_guide_na": "Guide de voyage non disponible pour le moment. Réservez maintenant votre transfert vers {city}.",
    "cp_more_dest": "D'autres destinations",
    "cp_all_places": "Tous les lieux",
    "cp_seo_title": "Transfert aéroport & Taxi {city}",
    "cp_seo_desc": "Transfert aéroport premium, taxi & service de chauffeur à {city}. Prix fixes depuis l'aéroport de Zürich (ZRH), chauffeurs professionnels et suivi de vol 24/7.",
    "cp_prices_for": "Prix pour transfert aéroport vers {city}",
    "cp_prices_note": "Prix fixes par catégorie de véhicule (estimation depuis l'aéroport de Zürich, y compris taxes).",
    "cp_ready_transfer": "Prêt pour votre transfert vers {city} ?",
    "cp_fixed_sec": "Prix fixe en quelques secondes – sans compte.",
    "cp_book_now": "Réservez maintenant",
    "bp_step_route": "Itinéraire",
    "bp_step_vehicle": "Véhicule",
    "bp_step_details": "Détails",
    "bp_step_confirm": "Confirmation",
    "bp_title": "Réserver un transfert",
    "bp_subtitle": "Prix fixe en quelques secondes — chauffeurs professionnels à travers la Suisse.",
    "bp_pickup": "Adresse de prise en charge",
    "bp_pickup_ph": "Adresse, aéroport, hôtel…",
    "bp_dropoff": "Adresse de destination",
    "bp_dropoff_ph": "Adresse de destination…",
    "bp_duration": "Durée",
    "bp_hours_unit": "{n} heures",
    "bp_date": "Date",
    "bp_date_ph": "Choisir une date",
    "bp_time": "Heure",
    "bp_time_ph": "Temps",
    "bp_see_prices": "Voir les prix",
    "bp_copy_share": "Copier & partager le lien",
    "bp_share_wa": "Partager via WhatsApp",
    "bp_copy_link": "Copier le lien",
    "bp_link_copied": "Lien copié",
    "bp_link_copied_d": "Itinéraire, date & heure sont enregistrés dans le lien.",
    "bp_copy_fail": "Échec de la copie",
    "bp_fill_all": "Veuillez remplir tous les champs",
    "bp_fill_all_d": "Adresse, date et heure sont requis.",
    "bp_error": "Erreur",
    "bp_route_error": "L'itinéraire n'a pas pu être calculé.",
    "bp_fill_contact": "Veuillez remplir les coordonnées",
    "bp_booking_failed": "La réservation a échoué.",
    "bp_your_ride": "Votre course",
    "bp_gratis": "(gratuit)",
    "bp_total": "Total",
    "bp_incl": "incl. TVA, temps d'attente & suivi de vol",
    "bp_fixed": "Prix fixe",
    "bp_select_next": "Sélectionner & continuer",
    "bp_back": "Retour",
    "bp_passenger_data": "Données des passagers",
    "bp_passengers": "Passagers",
    "bp_luggage": "Bagages",
    "bp_childseats": "Sièges enfants",
    "bp_childseats_note": "1. siège gratuit · chaque siège supplémentaire CHF 10",
    "bp_child": "Enfant",
    "bp_seat_baby": "Siège bébé · 0–1 an",
    "bp_seat_child": "Siège enfant · 1–6 ans",
    "bp_seat_boost": "Rehausseur · 6–12 ans",
    "bp_free": "gratuit",
    "bp_first_name": "Prénom",
    "bp_last_name": "Nom",
    "bp_email": "E-mail",
    "bp_phone": "Téléphone",
    "bp_flight_opt": "Numéro de vol (optionnel)",
    "bp_notes_opt": "Remarques (optionnelles)",
    "bp_payment": "Mode de paiement",
    "bp_card": "Carte de crédit",
    "bp_card_sub": "Payer en ligne",
    "bp_cash": "Espèces",
    "bp_cash_sub": "Dans le véhicule",
    "bp_secure_card": "Paiement en ligne sécurisé par carte de crédit (SumUp).",
    "bp_secure_cash": "Votre demande sera vérifiée et confirmée par e-mail.",
    "bp_pay_now": "Payer en ligne maintenant",
    "bp_send_request": "Envoyer la demande",
    "bp_received": "Demande reçue !",
    "bp_received_1": "Votre demande de réservation",
    "bp_received_2": "a été envoyée. Nous vérifions la disponibilité et vous enverrons une confirmation par e-mail dans les plus brefs délais.",
    "bp_vehicle": "Véhicule",
    "bp_price": "Prix",
    "bp_card_conf": "Carte de crédit (le lien de paiement suivra par e-mail)",
    "bp_cash_conf": "Paiement en espèces dans le véhicule",
    "bp_back_home": "Retour à la page d'accueil",
    "bl_eyebrow": "Blog",
    "bl_title": "Conseils, destinations & transferts",
    "bl_sub": "Guides pratiques pour tous nos services et un guide de transfert aéroport pour plus de 400 lieux en Suisse.",
    "bl_cat_flughafen": "Transfert aéroport",
    "bl_cat_flughafen_d": "Depuis & vers l'aéroport de Zürich à prix fixe.",
    "bl_cat_city": "Ville à ville",
    "bl_cat_city_d": "Directement entre les villes suisses.",
    "bl_cat_hourly": "Réservation à l'heure",
    "bl_cat_hourly_d": "Votre chauffeur pour toute la journée.",
    "bl_cat_biz": "Affaires",
    "bl_cat_biz_d": "Mobilité discrète pour les entreprises.",
    "bl_learn_more": "En savoir plus",
    "bl_read_more": "Lire la suite",
    "bl_read_time": "Temps de lecture",
    "bl_dir_title": "Transfert aéroport vers lieu",
    "bl_dir_sub": "Plus de {n} lieux en Suisse – chacun avec son propre guide. Recherchez votre destination.",
    "bl_search_ph": "Rechercher un lieu, par ex. Berne, Interlaken…",
    "bl_no_city": "Aucun lieu trouvé.",
    "ci_eyebrow": "Destinations",
    "ci_title": "Transferts à travers la Suisse",
    "ci_sub": "Depuis chaque aéroport vers chaque ville et chaque village de montagne. Choisissez votre destination ou réservez directement.",
    "ci_popular": "Lieux populaires",
    "pp_eyebrow": "Prix",
    "pp_title": "Tarifs fixes transparents",
    "pp_sub": "Chaque course à un prix fixe : un tarif de base par catégorie de véhicule plus un tarif au kilomètre. Exemple Économie : à partir de CHF 70, puis CHF 2.20/km. Pas de frais cachés.",
    "pp_f1_t": "Prix fixe garanti",
    "pp_f1_d": "Prix fixé lors de la réservation.",
    "pp_f2_t": "Suivi de vol",
    "pp_f2_d": "Temps d'attente gratuit en cas de retard.",
    "pp_f3_t": "Inclus",
    "pp_f3_d": "Taxes, péages & Meet-&-Greet inclus.",
    "pp_classes": "Nos catégories de véhicules & prix",
    "pp_book": "Réserver",
    "pp_dir_title": "Prix par destination",
    "pp_dir_sub": "Plus de {n} lieux en Suisse et dans les pays voisins. Choisissez votre destination pour le guide des prix fixes.",
    "pp_from": "à partir de",
    "ct_eyebrow": "Contact",
    "ct_title": "Nous sommes à votre service",
    "ct_sub": "Des questions sur votre course ou des souhaits particuliers ? Contactez-nous à tout moment – par téléphone, via WhatsApp ou par e-mail.",
    "ct_phone": "Téléphone",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "E-mail",
    "ct_address": "Adresse",
    "ct_name": "Nom",
    "ct_message": "Message",
    "ct_send": "Envoyer le message",
    "ct_required": "Veuillez remplir tous les champs obligatoires",
    "ct_sent": "Message envoyé",
    "ct_sent_d": "Nous vous répondrons dès que possible.",
    "ct_fail": "Le message n'a pas pu être envoyé.",
    "ba_back": "Retour au blog",
    "ba_transfer_to": "Transfert aéroport vers {city}",
    "ba_guide_creating": "Guide de voyage pour {city} en cours de création…",
    "ba_guide_creating_note": "Cela peut prendre jusqu'à une minute la première fois.",
    "ba_book_now_transfer": "Réservez maintenant votre transfert vers {city}.",
    "ba_ready_generic": "Prêt pour votre transfert ?",
    "ba_not_found": "Article non trouvé",
    "ba_to_blog": "Vers le blog",
    "ba_more_articles": "Autres articles",
    "hero_eyebrow": "Aéroport de Zürich · Service de chauffeur suisse",
    "hero_book_wa": "Réservez via WhatsApp",
    "hero_trust_sub": "Populaire auprès des voyageurs à l'aéroport de Zürich",
    "ft_desc": "Service de transfert aéroport et de chauffeur premium à travers toute la Suisse.",
    "ft_services": "Services",
    "ft_company": "Entreprise",
    "ft_popular": "Lieux populaires",
    "ft_svc_flughafen": "Transfert aéroport",
    "ft_svc_city": "Ville à ville",
    "ft_svc_hourly": "Réservation à l'heure",
    "ft_svc_biz": "Voyages d'affaires",
    "ft_fleet": "Notre flotte",
    "ft_dest": "Destinations",
    "ft_blog": "Blog",
    "ft_contact": "Contact",
    "ft_rights": "Tous droits réservés.",
    "ft_legal": "Confidentialité · CGV · Imprimerie",
    "dest_learn_more": "En savoir plus"
  },
  "it": {
    "cp_kw_label": "Transfer aeroportuale",
    "cp_eyebrow": "Transfer aeroportuale Zürich",
    "cp_taxi_limo": "Taxi & Limousine",
    "cp_b1": "Prezzo fisso",
    "cp_b2": "Monitoraggio voli 24/7",
    "cp_b3": "Autisti autorizzati",
    "cp_calc_price": "Calcola il prezzo",
    "cp_f1_t": "Prezzi fissi",
    "cp_f1_d": "Il tuo prezzo è fisso prima della corsa – nessuna sorpresa.",
    "cp_f2_t": "Sempre puntuali",
    "cp_f2_d": "Monitoriamo il tuo volo e ci adeguiamo.",
    "cp_f3_t": "Sicuro & autorizzato",
    "cp_f3_d": "Autisti svizzeri qualificati, veicoli mantenuti.",
    "cp_vehicles_for": "Veicoli per {city}",
    "cp_seats": "Posti",
    "cp_guide_loading": "Guida dettagliata per {city} in caricamento…",
    "cp_guide_na": "Guida attualmente non disponibile. Prenota subito il tuo transfer per {city}.",
    "cp_more_dest": "Altre destinazioni",
    "cp_all_places": "Tutti i luoghi",
    "cp_seo_title": "Transfer aeroportuale & Taxi {city}",
    "cp_seo_desc": "Transfer aeroportuale premium, Taxi & servizio chauffeur in {city}. Prezzi fissi dall'aeroporto di Zürich (ZRH), autisti professionali e monitoraggio voli 24 ore su 24.",
    "cp_prices_for": "Prezzi per transfer aeroportuale a {city}",
    "cp_prices_note": "Prezzi fissi per classe di veicolo (indicativo dall'aeroporto di Zürich, tasse incluse).",
    "cp_ready_transfer": "Pronto per il tuo transfer verso {city}?",
    "cp_fixed_sec": "Prezzo fisso in secondi – senza registrazione.",
    "cp_book_now": "Prenota ora",
    "bp_step_route": "Percorso",
    "bp_step_vehicle": "Veicolo",
    "bp_step_details": "Dettagli",
    "bp_step_confirm": "Conferma",
    "bp_title": "Prenota transfer",
    "bp_subtitle": "Prezzo fisso in secondi — autisti professionali in tutta la Svizzera.",
    "bp_pickup": "Indirizzo di ritiro",
    "bp_pickup_ph": "Indirizzo, aeroporto, hotel…",
    "bp_dropoff": "Indirizzo di destinazione",
    "bp_dropoff_ph": "Indirizzo di destinazione…",
    "bp_duration": "Durata",
    "bp_hours_unit": "{n} ore",
    "bp_date": "Data",
    "bp_date_ph": "Seleziona una data",
    "bp_time": "Orario",
    "bp_time_ph": "Ora",
    "bp_see_prices": "Visualizza prezzi",
    "bp_copy_share": "Copia e condividi il link",
    "bp_share_wa": "Condividi su WhatsApp",
    "bp_copy_link": "Copia link",
    "bp_link_copied": "Link copiato",
    "bp_link_copied_d": "Percorso, data & ora sono stati salvati nel link.",
    "bp_copy_fail": "Copia fallita",
    "bp_fill_all": "Compila tutti i campi",
    "bp_fill_all_d": "Indirizzo, data e ora sono necessari.",
    "bp_error": "Errore",
    "bp_route_error": "Impossibile calcolare il percorso.",
    "bp_fill_contact": "Compila i dati di contatto",
    "bp_booking_failed": "Prenotazione fallita.",
    "bp_your_ride": "La tua corsa",
    "bp_gratis": "(gratuito)",
    "bp_total": "Totale",
    "bp_incl": "incl. IVA, tempo di attesa & monitoraggio voli",
    "bp_fixed": "Prezzo fisso",
    "bp_select_next": "Seleziona & continua",
    "bp_back": "Indietro",
    "bp_passenger_data": "Dati passeggero",
    "bp_passengers": "Passeggeri",
    "bp_luggage": "Bagagli",
    "bp_childseats": "Seggiolini per bambini",
    "bp_childseats_note": "1° seggiolino gratuito · ogni ulteriore CHF 10",
    "bp_child": "Bambino",
    "bp_seat_baby": "Seggiolino per bambini · 0–1 anno",
    "bp_seat_child": "Seggiolino per bambini · 1–6 anni",
    "bp_seat_boost": "Alzatina · 6–12 anni",
    "bp_free": "gratuito",
    "bp_first_name": "Nome",
    "bp_last_name": "Cognome",
    "bp_email": "E-mail",
    "bp_phone": "Telefono",
    "bp_flight_opt": "Numero di volo (opzionale)",
    "bp_notes_opt": "Note (opzionali)",
    "bp_payment": "Metodo di pagamento",
    "bp_card": "Carta di credito",
    "bp_card_sub": "Paga online",
    "bp_cash": "Pagamento in contante",
    "bp_cash_sub": "A bordo del veicolo",
    "bp_secure_card": "Pagamento online sicuro con carta di credito (SumUp).",
    "bp_secure_cash": "La tua richiesta sarà verificata e confermata via e-mail.",
    "bp_pay_now": "Paga ora online",
    "bp_send_request": "Invia richiesta",
    "bp_received": "Richiesta ricevuta!",
    "bp_received_1": "La tua richiesta di prenotazione",
    "bp_received_2": "è stata inviata. Controlliamo la disponibilità e ti invieremo conferma via e-mail il prima possibile.",
    "bp_vehicle": "Veicolo",
    "bp_price": "Prezzo",
    "bp_card_conf": "Carta di credito (link di pagamento seguirà via e-mail)",
    "bp_cash_conf": "Pagamento in contante a bordo",
    "bp_back_home": "Torna alla home",
    "bl_eyebrow": "Blog",
    "bl_title": "Guide, destinazioni & transfer",
    "bl_sub": "Guide pratiche per tutti i nostri servizi e una guida per transfer aeroportuali per oltre 400 luoghi in Svizzera.",
    "bl_cat_flughafen": "Transfer aeroportuale",
    "bl_cat_flughafen_d": "Da & per l'aeroporto di Zürich a prezzo fisso.",
    "bl_cat_city": "Città a città",
    "bl_cat_city_d": "Direttamente tra le città svizzere.",
    "bl_cat_hourly": "Prenotazione oraria",
    "bl_cat_hourly_d": "Il tuo autista per l'intera giornata.",
    "bl_cat_biz": "Affari",
    "bl_cat_biz_d": "Mobilità discreta per le aziende.",
    "bl_learn_more": "Scopri di più",
    "bl_read_more": "Leggi di più",
    "bl_read_time": "Tempo di lettura",
    "bl_dir_title": "Transfer aeroportuale per località",
    "bl_dir_sub": "Oltre {n} luoghi in Svizzera – ognuno con la propria guida. Cerca la tua destinazione.",
    "bl_search_ph": "Cerca un luogo, es. Berna, Interlaken…",
    "bl_no_city": "Nessun luogo trovato.",
    "ci_eyebrow": "Destinazioni",
    "ci_title": "Transfer in tutta la Svizzera",
    "ci_sub": "Da ogni aeroporto a ogni città e villaggio montano. Scegli la tua destinazione o prenota direttamente.",
    "ci_popular": "Luoghi popolari",
    "pp_eyebrow": "Prezzi",
    "pp_title": "Prezzi fissi trasparenti",
    "pp_sub": "Ogni corsa a un prezzo fisso: un prezzo base per classe di veicolo più un prezzo al chilometro. Esempio Economy: da CHF 70, poi CHF 2.20/km. Nessun costo nascosto.",
    "pp_f1_t": "Prezzo fisso garantito",
    "pp_f1_d": "Prezzo fissato alla prenotazione.",
    "pp_f2_t": "Monitoraggio voli",
    "pp_f2_d": "Tempo di attesa gratuito in caso di ritardo.",
    "pp_f3_t": "Incluso",
    "pp_f3_d": "Tasse, pedaggi & Meet-&-Greet inclusi.",
    "pp_classes": "Le nostre classi di veicolo & prezzi",
    "pp_book": "Prenota",
    "pp_dir_title": "Prezzi per destinazione",
    "pp_dir_sub": "Oltre {n} luoghi in Svizzera e nei paesi limitrofi. Scegli la tua destinazione per la guida ai prezzi fissi.",
    "pp_from": "da",
    "ct_eyebrow": "Contatto",
    "ct_title": "Siamo qui per te",
    "ct_sub": "Domande sul tuo viaggio o richieste particolari? Contattaci 24 ore su 24 — telefonicamente, tramite WhatsApp o e-mail.",
    "ct_phone": "Telefono",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "E-mail",
    "ct_address": "Indirizzo",
    "ct_name": "Nome",
    "ct_message": "Messaggio",
    "ct_send": "Invia messaggio",
    "ct_required": "Compila tutti i campi obbligatori",
    "ct_sent": "Messaggio inviato",
    "ct_sent_d": "Ti contatteremo il prima possibile.",
    "ct_fail": "Impossibile inviare il messaggio.",
    "ba_back": "Torna al blog",
    "ba_transfer_to": "Transfer aeroportuale per {city}",
    "ba_guide_creating": "Guida per {city} in fase di creazione…",
    "ba_guide_creating_note": "Questo può richiedere fino a un minuto al primo accesso.",
    "ba_book_now_transfer": "Prenota subito il tuo transfer per {city}.",
    "ba_ready_generic": "Pronto per il tuo transfer?",
    "ba_not_found": "Articolo non trovato",
    "ba_to_blog": "Vai al blog",
    "ba_more_articles": "Altri articoli",
    "hero_eyebrow": "Aeroporto di Zürich · Servizio chauffeur svizzero",
    "hero_book_wa": "Prenota tramite WhatsApp",
    "hero_trust_sub": "Popolare tra i viaggiatori all'aeroporto di Zürich",
    "ft_desc": "Servizio chauffeur e transfer aeroportuali premium in tutta la Svizzera.",
    "ft_services": "Servizi",
    "ft_company": "Azienda",
    "ft_popular": "Luoghi popolari",
    "ft_svc_flughafen": "Transfer aeroportuale",
    "ft_svc_city": "Città a città",
    "ft_svc_hourly": "Prenotazione oraria",
    "ft_svc_biz": "Viaggi d'affari",
    "ft_fleet": "La nostra flotta",
    "ft_dest": "Destinazioni",
    "ft_blog": "Blog",
    "ft_contact": "Contatto",
    "ft_rights": "Tutti i diritti riservati.",
    "ft_legal": "Privacy · Termini · Impressum",
    "dest_learn_more": "Scopri di più"
  },
  "es": {
    "cp_kw_label": "Transfer de Aeropuerto",
    "cp_eyebrow": "Transfer de Aeropuerto en Zürich",
    "cp_taxi_limo": "Taxi y Limusina",
    "cp_b1": "Precio fijo",
    "cp_b2": "Seguimiento de vuelos 24/7",
    "cp_b3": "Conductores licenciados",
    "cp_calc_price": "Calcular precio",
    "cp_f1_t": "Precios fijos",
    "cp_f1_d": "Su precio se fija antes del viaje – sin sorpresas.",
    "cp_f2_t": "Siempre puntuales",
    "cp_f2_d": "Seguimos su vuelo y nos adaptamos.",
    "cp_f3_t": "Seguro y licenciado",
    "cp_f3_d": "Chóferes suizos capacitados, vehículos bien cuidados.",
    "cp_vehicles_for": "Vehículos para {city}",
    "cp_seats": "Asientos",
    "cp_guide_loading": "Cargando guía detallada para {city}…",
    "cp_guide_na": "Guía no disponible actualmente. Reserve su traslado a {city} ahora.",
    "cp_more_dest": "Más destinos",
    "cp_all_places": "Todos los lugares",
    "cp_seo_title": "Transfer de Aeropuerto & Taxi {city}",
    "cp_seo_desc": "Transfer de aeropuerto premium, taxi & servicio de chófer en {city}. Precios fijos desde el Aeropuerto de Zürich (ZRH), conductores profesionales y seguimiento de vuelos las 24 horas.",
    "cp_prices_for": "Precios para transfer de aeropuerto a {city}",
    "cp_prices_note": "Precios fijos por clase de vehículo (precio orientativo desde el Aeropuerto de Zürich, impuestos incluidos).",
    "cp_ready_transfer": "¿Listo para su traslado a {city}?",
    "cp_fixed_sec": "Precio fijo en segundos – sin necesidad de cuenta.",
    "cp_book_now": "Reservar ahora",
    "bp_step_route": "Ruta",
    "bp_step_vehicle": "Vehículo",
    "bp_step_details": "Detalles",
    "bp_step_confirm": "Confirmación",
    "bp_title": "Reservar traslado",
    "bp_subtitle": "Precio fijo en segundos — chóferes profesionales en toda Suiza.",
    "bp_pickup": "Dirección de recogida",
    "bp_pickup_ph": "Dirección, aeropuerto, hotel…",
    "bp_dropoff": "Dirección de destino",
    "bp_dropoff_ph": "Dirección de destino…",
    "bp_duration": "Duración",
    "bp_hours_unit": "{n} horas",
    "bp_date": "Fecha",
    "bp_date_ph": "Seleccionar fecha",
    "bp_time": "Hora",
    "bp_time_ph": "Hora",
    "bp_see_prices": "Ver precios",
    "bp_copy_share": "Copiar y compartir enlace",
    "bp_share_wa": "Compartir por WhatsApp",
    "bp_copy_link": "Copiar enlace",
    "bp_link_copied": "Enlace copiado",
    "bp_link_copied_d": "Ruta, fecha y hora están guardadas en el enlace.",
    "bp_copy_fail": "Error al copiar",
    "bp_fill_all": "Por favor, complete todos los campos",
    "bp_fill_all_d": "Se necesita dirección, fecha y hora.",
    "bp_error": "Error",
    "bp_route_error": "No se pudo calcular la ruta.",
    "bp_fill_contact": "Por favor, complete los datos de contacto",
    "bp_booking_failed": "Error en la reserva.",
    "bp_your_ride": "Su viaje",
    "bp_gratis": "(gratis)",
    "bp_total": "Total",
    "bp_incl": "incl. IVA, tiempo de espera y seguimiento de vuelo",
    "bp_fixed": "Precio fijo",
    "bp_select_next": "Seleccionar y continuar",
    "bp_back": "Atrás",
    "bp_passenger_data": "Datos del pasajero",
    "bp_passengers": "Pasajeros",
    "bp_luggage": "Equipaje",
    "bp_childseats": "Asientos para niños",
    "bp_childseats_note": "1. asiento gratis · cada uno adicional CHF 10",
    "bp_child": "Niño",
    "bp_seat_baby": "Silla para bebés · 0–1 año",
    "bp_seat_child": "Asiento para niños · 1–6 años",
    "bp_seat_boost": "Elevador · 6–12 años",
    "bp_free": "gratis",
    "bp_first_name": "Nombre",
    "bp_last_name": "Apellido",
    "bp_email": "Correo electrónico",
    "bp_phone": "Teléfono",
    "bp_flight_opt": "Número de vuelo (opcional)",
    "bp_notes_opt": "Notas (opcional)",
    "bp_payment": "Método de pago",
    "bp_card": "Tarjeta de crédito",
    "bp_card_sub": "Pagar en línea",
    "bp_cash": "Pago en efectivo",
    "bp_cash_sub": "En el vehículo",
    "bp_secure_card": "Pago seguro en línea por tarjeta de crédito (SumUp).",
    "bp_secure_cash": "Su solicitud será revisada y confirmada por correo electrónico.",
    "bp_pay_now": "Pagar ahora en línea",
    "bp_send_request": "Enviar solicitud",
    "bp_received": "¡Solicitud recibida!",
    "bp_received_1": "Su solicitud de reserva",
    "bp_received_2": "ha sido enviada. Revisaremos la disponibilidad y le enviaremos una confirmación por correo electrónico de inmediato.",
    "bp_vehicle": "Vehículo",
    "bp_price": "Precio",
    "bp_card_conf": "Tarjeta de crédito (enlace de pago seguirá por correo electrónico)",
    "bp_cash_conf": "Pago en efectivo en el vehículo",
    "bp_back_home": "Volver a la página principal",
    "bl_eyebrow": "Blog",
    "bl_title": "Guía, destinos & traslados",
    "bl_sub": "Guías prácticas sobre todos nuestros servicios y una guía de transfer de aeropuerto para más de 400 lugares en Suiza.",
    "bl_cat_flughafen": "Transfer de Aeropuerto",
    "bl_cat_flughafen_d": "Desde y hacia el Aeropuerto de Zürich a precio fijo.",
    "bl_cat_city": "Ciudad a ciudad",
    "bl_cat_city_d": "Directo entre ciudades suizas.",
    "bl_cat_hourly": "Reserva por horas",
    "bl_cat_hourly_d": "Su chófer durante todo el día.",
    "bl_cat_biz": "Negocios",
    "bl_cat_biz_d": "Movilidad discreta para empresas.",
    "bl_learn_more": "Aprender más",
    "bl_read_more": "Leer más",
    "bl_read_time": "Tiempo de lectura",
    "bl_dir_title": "Transfer de Aeropuerto a ubicación",
    "bl_dir_sub": "Más de {n} lugares en Suiza – cada uno con su propia guía de viaje. Busque su destino.",
    "bl_search_ph": "Buscar lugar, p. ej. Berna, Interlaken…",
    "bl_no_city": "No se encontró lugar.",
    "ci_eyebrow": "Destinos",
    "ci_title": "Traslados en toda Suiza",
    "ci_sub": "Desde cualquier aeropuerto a cualquier ciudad y pueblo de montaña. Elija su destino o reserve directamente.",
    "ci_popular": "Lugares populares",
    "pp_eyebrow": "Precios",
    "pp_title": "Precios fijos transparentes",
    "pp_sub": "Cada viaje a un precio fijo: un precio base por clase de vehículo más un precio por kilómetro. Ejemplo Economy: desde CHF 70, luego CHF 2.20/km. Sin costos ocultos.",
    "pp_f1_t": "Precio fijo garantizado",
    "pp_f1_d": "Precio fijado al realizar la reserva.",
    "pp_f2_t": "Seguimiento de vuelos",
    "pp_f2_d": "Período de espera gratuito en caso de retraso.",
    "pp_f3_t": "Incluido",
    "pp_f3_d": "Impuestos, peajes & Meet-&-Greet incluidos.",
    "pp_classes": "Nuestras clases de vehículo & precios",
    "pp_book": "Reservar",
    "pp_dir_title": "Precios por destino",
    "pp_dir_sub": "Más de {n} lugares en Suiza y países vecinos. Seleccione su destino para la guía de precios fijos.",
    "pp_from": "desde",
    "ct_eyebrow": "Contacto",
    "ct_title": "Estamos aquí para usted",
    "ct_sub": "¿Preguntas sobre su viaje o solicitudes especiales? Contáctenos las 24 horas del día, por teléfono, por WhatsApp o por correo electrónico.",
    "ct_phone": "Teléfono",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "Correo electrónico",
    "ct_address": "Dirección",
    "ct_name": "Nombre",
    "ct_message": "Mensaje",
    "ct_send": "Enviar mensaje",
    "ct_required": "Por favor, complete todos los campos obligatorios",
    "ct_sent": "Mensaje enviado",
    "ct_sent_d": "Nos pondremos en contacto lo antes posible.",
    "ct_fail": "No se pudo enviar el mensaje.",
    "ba_back": "Volver al blog",
    "ba_transfer_to": "Transfer de Aeropuerto a {city}",
    "ba_guide_creating": "Creando guía para {city}…",
    "ba_guide_creating_note": "Esto puede tardar hasta un minuto en la primera solicitud.",
    "ba_book_now_transfer": "Reserve ahora su traslado a {city}.",
    "ba_ready_generic": "¿Listo para su traslado?",
    "ba_not_found": "Artículo no encontrado",
    "ba_to_blog": "Al blog",
    "ba_more_articles": "Más artículos",
    "hero_eyebrow": "Aeropuerto de Zürich · Servicio de Chófer Suizo",
    "hero_book_wa": "Reservar por WhatsApp",
    "hero_trust_sub": "Popular entre los viajeros en el Aeropuerto de Zürich",
    "ft_desc": "Servicio premium de chófer y traslados de aeropuerto en toda Suiza.",
    "ft_services": "Servicios",
    "ft_company": "Empresa",
    "ft_popular": "Lugares populares",
    "ft_svc_flughafen": "Transfer de Aeropuerto",
    "ft_svc_city": "Ciudad a ciudad",
    "ft_svc_hourly": "Reserva por horas",
    "ft_svc_biz": "Viajes de negocio",
    "ft_fleet": "Nuestra flota",
    "ft_dest": "Destinos",
    "ft_blog": "Blog",
    "ft_contact": "Contacto",
    "ft_rights": "Todos los derechos reservados.",
    "ft_legal": "Privacidad · Términos y condiciones · Aviso Legal",
    "dest_learn_more": "Aprender más"
  },
  "pt": {
    "cp_kw_label": "Transfer de Aeroporto",
    "cp_eyebrow": "Transfer de Aeroporto em Zürich",
    "cp_taxi_limo": "Taxi & Limusine",
    "cp_b1": "Preço Fixo",
    "cp_b2": "Rastreamento de Voo 24/7",
    "cp_b3": "Motoristas Licenciados",
    "cp_calc_price": "Calcular Preço",
    "cp_f1_t": "Preços Fixos",
    "cp_f1_d": "Seu preço é garantido antes da viagem - sem surpresas.",
    "cp_f2_t": "Sempre Pontual",
    "cp_f2_d": "Monitoramos seu voo e nos adaptamos.",
    "cp_f3_t": "Seguro & Licenciado",
    "cp_f3_d": "Motoristas suíços treinados, veículos bem cuidados.",
    "cp_vehicles_for": "Veículos para {city}",
    "cp_seats": "Assentos",
    "cp_guide_loading": "Carregando guia detalhado para {city}…",
    "cp_guide_na": "Guia não disponível no momento. Reserve agora seu transfer para {city}.",
    "cp_more_dest": "Mais Destinos",
    "cp_all_places": "Todos os Locais",
    "cp_seo_title": "Transfer de Aeroporto & Taxi {city}",
    "cp_seo_desc": "Transfer de aeroporto premium, taxi & serviço de motorista em {city}. Preços fixos a partir do Aeroporto de Zürich (ZRH), motoristas profissionais e rastreamento de voo 24 horas.",
    "cp_prices_for": "Preços para transfer de aeroporto para {city}",
    "cp_prices_note": "Preços fixos por categoria de veículo (valor padrão do Aeroporto de Zürich, incluindo impostos).",
    "cp_ready_transfer": "Pronto para seu transfer para {city}?",
    "cp_fixed_sec": "Preço fixo em segundos — sem necessidade de conta.",
    "cp_book_now": "Reserve agora",
    "bp_step_route": "Rota",
    "bp_step_vehicle": "Veículo",
    "bp_step_details": "Detalhes",
    "bp_step_confirm": "Confirmação",
    "bp_title": "Reservar Transfer",
    "bp_subtitle": "Preço fixo em segundos — motoristas profissionais em toda a Suíça.",
    "bp_pickup": "Endereço de Coleta",
    "bp_pickup_ph": "Endereço, aeroporto, hotel…",
    "bp_dropoff": "Endereço de Destino",
    "bp_dropoff_ph": "Endereço de destino…",
    "bp_duration": "Duração",
    "bp_hours_unit": "{n} Horas",
    "bp_date": "Data",
    "bp_date_ph": "Escolher Data",
    "bp_time": "Hora",
    "bp_time_ph": "Hora",
    "bp_see_prices": "Ver Preços",
    "bp_copy_share": "Copiar Link & Compartilhar",
    "bp_share_wa": "Compartilhar pelo WhatsApp",
    "bp_copy_link": "Copiar Link",
    "bp_link_copied": "Link Copiado",
    "bp_link_copied_d": "Rota, data & hora estão salvos no link.",
    "bp_copy_fail": "Falha ao copiar",
    "bp_fill_all": "Por favor preencha todos os campos",
    "bp_fill_all_d": "Endereço, data e hora são necessários.",
    "bp_error": "Erro",
    "bp_route_error": "Não foi possível calcular a rota.",
    "bp_fill_contact": "Por favor, preencha as informações de contato",
    "bp_booking_failed": "Reserva falhou.",
    "bp_your_ride": "Sua Viagem",
    "bp_gratis": "(grátis)",
    "bp_total": "Total",
    "bp_incl": "incl. IVA, tempo de espera & rastreamento de voo",
    "bp_fixed": "Preço Fixo",
    "bp_select_next": "Selecionar & continuar",
    "bp_back": "Voltar",
    "bp_passenger_data": "Dados do passageiro",
    "bp_passengers": "Passageiros",
    "bp_luggage": "Bagagem",
    "bp_childseats": "Cadeirinhas",
    "bp_childseats_note": "1. cadeira grátis · cada adicional CHF 10",
    "bp_child": "Criança",
    "bp_seat_baby": "Assento para bebês · 0–1 ano",
    "bp_seat_child": "Cadeirinha · 1–6 anos",
    "bp_seat_boost": "Assento elevatório · 6–12 anos",
    "bp_free": "grátis",
    "bp_first_name": "Primeiro Nome",
    "bp_last_name": "Sobrenome",
    "bp_email": "E-mail",
    "bp_phone": "Telefone",
    "bp_flight_opt": "Número do voo (opcional)",
    "bp_notes_opt": "Observações (opcional)",
    "bp_payment": "Forma de pagamento",
    "bp_card": "Cartão de Crédito",
    "bp_card_sub": "Pagar online",
    "bp_cash": "Pagamento em Dinheiro",
    "bp_cash_sub": "No veículo",
    "bp_secure_card": "Pagamento online seguro por cartão de crédito (SumUp).",
    "bp_secure_cash": "Seu pedido será verificado e confirmado por e-mail.",
    "bp_pay_now": "Pagar agora online",
    "bp_send_request": "Enviar solicitação",
    "bp_received": "Solicitação recebida!",
    "bp_received_1": "Seu pedido de reserva",
    "bp_received_2": "foi enviado. Estamos verificando a disponibilidade e enviaremos uma confirmação por e-mail em breve.",
    "bp_vehicle": "Veículo",
    "bp_price": "Preço",
    "bp_card_conf": "Cartão de Crédito (link de pagamento será enviado por e-mail)",
    "bp_cash_conf": "Pagamento em dinheiro no veículo",
    "bp_back_home": "Voltar para a Página Inicial",
    "bl_eyebrow": "Blog",
    "bl_title": "Guias, Destinos & Transfers",
    "bl_sub": "Guias práticos sobre todos os nossos serviços e um guia de transfer de aeroporto para mais de 400 locais na Suíça.",
    "bl_cat_flughafen": "Transfer de Aeroporto",
    "bl_cat_flughafen_d": "Do & para o Aeroporto de Zürich a preço fixo.",
    "bl_cat_city": "Cidade a Cidade",
    "bl_cat_city_d": "Diretamente entre cidades suíças.",
    "bl_cat_hourly": "Horário",
    "bl_cat_hourly_d": "Seu motorista por um dia inteiro.",
    "bl_cat_biz": "Negócios",
    "bl_cat_biz_d": "Mobilidade discreta para empresas.",
    "bl_learn_more": "Saiba mais",
    "bl_read_more": "Leia mais",
    "bl_read_time": "Tempo de Leitura",
    "bl_dir_title": "Transfer de Aeroporto para Local",
    "bl_dir_sub": "Sobre {n} locais na Suíça – cada um com seu próprio guia. Procure seu destino.",
    "bl_search_ph": "Procurar local, por exemplo, Berna, Interlaken…",
    "bl_no_city": "Nenhum local encontrado.",
    "ci_eyebrow": "Destinos",
    "ci_title": "Transfers em toda a Suíça",
    "ci_sub": "De qualquer aeroporto para qualquer cidade e vila nas montanhas. Escolha seu destino ou reserve diretamente.",
    "ci_popular": "Locais Populares",
    "pp_eyebrow": "Preços",
    "pp_title": "Preços fixos transparentes",
    "pp_sub": "Cada viagem a um preço fixo: um preço básico por categoria de veículo mais um preço por quilômetro. Exemplo Econômico: a partir de CHF 70, depois CHF 2.20/km. Sem custos ocultos.",
    "pp_f1_t": "Preço Fixo Garantido",
    "pp_f1_d": "Preço fixo na hora da reserva.",
    "pp_f2_t": "Rastreamento de Voo",
    "pp_f2_d": "Tempo de espera grátis em caso de atraso.",
    "pp_f3_t": "Incluso",
    "pp_f3_d": "Impostos, pedágios & Meet-&-Greet inclusos.",
    "pp_classes": "Nossas categorias de veículos & preços",
    "pp_book": "Reservar",
    "pp_dir_title": "Preços por Destino",
    "pp_dir_sub": "Sobre {n} locais na Suíça e países vizinhos. Escolha seu destino para o guia de preços fixos.",
    "pp_from": "a partir de",
    "ct_eyebrow": "Contato",
    "ct_title": "Estamos aqui para você",
    "ct_sub": "Dúvidas sobre sua viagem ou pedidos especiais? Entre em contato conosco 24 horas por dia — por telefone, WhatsApp ou e-mail.",
    "ct_phone": "Telefone",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "E-mail",
    "ct_address": "Endereço",
    "ct_name": "Nome",
    "ct_message": "Mensagem",
    "ct_send": "Enviar Mensagem",
    "ct_required": "Por favor, preencha todos os campos obrigatórios",
    "ct_sent": "Mensagem enviada",
    "ct_sent_d": "Responderemos o mais breve possível.",
    "ct_fail": "Falha ao enviar mensagem.",
    "ba_back": "Voltar ao Blog",
    "ba_transfer_to": "Transfer de Aeroporto para {city}",
    "ba_guide_creating": "Guia para {city} está sendo criado…",
    "ba_guide_creating_note": "Isso pode levar até um minuto na primeira chamada.",
    "ba_book_now_transfer": "Reserve agora seu transfer para {city}.",
    "ba_ready_generic": "Pronto para seu transfer?",
    "ba_not_found": "Artigo não encontrado",
    "ba_to_blog": "Ir ao Blog",
    "ba_more_articles": "Mais Artigos",
    "hero_eyebrow": "Aeroporto de Zürich · Serviço de Motorista Suíço",
    "hero_book_wa": "Reservar pelo WhatsApp",
    "hero_trust_sub": "Popular entre viajantes no Aeroporto de Zürich",
    "ft_desc": "Serviço premium de motorista e transfer de aeroporto em toda a Suíça.",
    "ft_services": "Serviços",
    "ft_company": "Empresa",
    "ft_popular": "Locais Populares",
    "ft_svc_flughafen": "Transfer de Aeroporto",
    "ft_svc_city": "Cidade a Cidade",
    "ft_svc_hourly": "Horário",
    "ft_svc_biz": "Viagens de Negócios",
    "ft_fleet": "Nossa Frota",
    "ft_dest": "Destinos",
    "ft_blog": "Blog",
    "ft_contact": "Contato",
    "ft_rights": "Todos os direitos reservados.",
    "ft_legal": "Privacidade · Termos · Impressum",
    "dest_learn_more": "Saiba mais"
  },
  "tr": {
    "cp_kw_label": "Havaalanı Transferi",
    "cp_eyebrow": "Zürich Havaalanı Transferi",
    "cp_taxi_limo": "Taksi & Limuzin",
    "cp_b1": "Sabit Fiyat",
    "cp_b2": "24/7 Uçuş Takibi",
    "cp_b3": "Lisanslı Şoförler",
    "cp_calc_price": "Fiyat Hesapla",
    "cp_f1_t": "Sabit Fiyatlar",
    "cp_f1_d": "Fiyatınız yolculuktan önce belirlenir – sürpriz yok.",
    "cp_f2_t": "Her Zaman Zamanında",
    "cp_f2_d": "Uçuşunuzu izliyoruz ve buna göre ayarlıyoruz.",
    "cp_f3_t": "Güvenli & Lisanslı",
    "cp_f3_d": "Eğitimli İsviçreli şoförler, iyi bakımlı araçlar.",
    "cp_vehicles_for": "{city} için araçlar",
    "cp_seats": "Koltuklar",
    "cp_guide_loading": "{city} için detaylı rehber yükleniyor…",
    "cp_guide_na": "Rehber şu anda mevcut değil. Şimdi {city} için transferinizi rezervasyon yapın.",
    "cp_more_dest": "Diğer Destinasyonlar",
    "cp_all_places": "Tüm Yerler",
    "cp_seo_title": "Havaalanı Transferi & Taksi {city}",
    "cp_seo_desc": "Premium havaalanı transferi, taksi & şoför hizmeti {city}'de. Zürich Havaalanı'ndan (ZRH) sabit fiyatlar, profesyonel sürücüler ve 7/24 uçuş takibi.",
    "cp_prices_for": "{city} için havaalanı transferi fiyatları",
    "cp_prices_note": "Araç sınıfına göre sabit fiyatlar (Zürich Havaalanı'ndan itibaren, vergiler dahil).",
    "cp_ready_transfer": "{city} için transferinize hazır mısınız?",
    "cp_fixed_sec": "Saniyeler içinde sabit fiyat – hesap olmadan.",
    "cp_book_now": "Şimdi Rezervasyon Yap",
    "bp_step_route": "Rota",
    "bp_step_vehicle": "Araç",
    "bp_step_details": "Detaylar",
    "bp_step_confirm": "Onay",
    "bp_title": "Transfer Rezervasyonu",
    "bp_subtitle": "Saniyeler içinde sabit fiyat — İsviçre genelinde profesyonel şoförler.",
    "bp_pickup": "Alış Adresi",
    "bp_pickup_ph": "Adres, Havaalanı, Otel…",
    "bp_dropoff": "Bırakma Adresi",
    "bp_dropoff_ph": "Bırakma adresi…",
    "bp_duration": "Süre",
    "bp_hours_unit": "{n} Saat",
    "bp_date": "Tarih",
    "bp_date_ph": "Tarih Seçin",
    "bp_time": "Saat",
    "bp_time_ph": "Zaman",
    "bp_see_prices": "Fiyatları Gör",
    "bp_copy_share": "Bağlantıyı Kopyala & Paylaş",
    "bp_share_wa": "WhatsApp ile paylaş",
    "bp_copy_link": "Bağlantıyı Kopyala",
    "bp_link_copied": "Bağlantı kopyalandı",
    "bp_link_copied_d": "Rota, tarih & saat bağlantıda kaydedildi.",
    "bp_copy_fail": "Kopyalama başarısız",
    "bp_fill_all": "Lütfen tüm alanları doldurun",
    "bp_fill_all_d": "Adres, tarih ve saat gerekmektedir.",
    "bp_error": "Hata",
    "bp_route_error": "Rota hesaplanamadı.",
    "bp_fill_contact": "Lütfen iletişim bilgilerini doldurun",
    "bp_booking_failed": "Rezervasyon başarısız.",
    "bp_your_ride": "Seyahatiniz",
    "bp_gratis": "(ücretsiz)",
    "bp_total": "Toplam",
    "bp_incl": "dahil. KDV, bekleme süresi & uçuş takibi",
    "bp_fixed": "Sabit Fiyat",
    "bp_select_next": "Seç & İlerleyin",
    "bp_back": "Geri",
    "bp_passenger_data": "Yolcu Bilgileri",
    "bp_passengers": "Yolcular",
    "bp_luggage": "Bavul",
    "bp_childseats": "Çocuk Koltukları",
    "bp_childseats_note": "1. Koltuk ücretsiz · her bir sonraki CHF 10",
    "bp_child": "Çocuk",
    "bp_seat_baby": "Bebek Koltuğu · 0–1 yaş",
    "bp_seat_child": "Çocuk Koltuğu · 1–6 yaş",
    "bp_seat_boost": "Yükseltici · 6–12 yaş",
    "bp_free": "ücretsiz",
    "bp_first_name": "Ad",
    "bp_last_name": "Soyad",
    "bp_email": "E-posta",
    "bp_phone": "Telefon",
    "bp_flight_opt": "Uçuş Numarası (isteğe bağlı)",
    "bp_notes_opt": "Notlar (isteğe bağlı)",
    "bp_payment": "Ödeme Türü",
    "bp_card": "Kredi Kartı",
    "bp_card_sub": "Online ödeme",
    "bp_cash": "Nakit Ödeme",
    "bp_cash_sub": "Araçta",
    "bp_secure_card": "Güvenli Online Ödeme kredi kartıyla (SumUp).",
    "bp_secure_cash": "Talebiniz kontrol edilecek ve e-posta ile onaylanacaktır.",
    "bp_pay_now": "Şimdi online ödeme yap",
    "bp_send_request": "Talep gönder",
    "bp_received": "Talep alındı!",
    "bp_received_1": "Rezervasyon talebiniz",
    "bp_received_2": "gönderildi. Uygunluğu kontrol ediyoruz ve size hemen bir e-posta ile onay gönderiyoruz.",
    "bp_vehicle": "Araç",
    "bp_price": "Fiyat",
    "bp_card_conf": "Kredi Kartı (ödeme bağlantısı e-posta ile gönderilecektir)",
    "bp_cash_conf": "Araçta nakit ödeme",
    "bp_back_home": "Ana sayfaya dön",
    "bl_eyebrow": "Blog",
    "bl_title": "Rehber, Seyahat Noktaları & Transferler",
    "bl_sub": "Tüm hizmetlerimiz için pratik rehberler ve İsviçre'deki 400'den fazla yer için bir havaalanı transfer rehberi.",
    "bl_cat_flughafen": "Havaalanı Transferi",
    "bl_cat_flughafen_d": "Zürich Havaalanı'ndan & Havaalanı'na sabit fiyatla.",
    "bl_cat_city": "Şehirden Şehire",
    "bl_cat_city_d": "İsviçre şehirleri arasında doğrudan.",
    "bl_cat_hourly": "Saatlik Rezervasyon",
    "bl_cat_hourly_d": "Gün boyunca şoförünüz.",
    "bl_cat_biz": "İş Seyahati",
    "bl_cat_biz_d": "Şirketler için gizli mobilite.",
    "bl_learn_more": "Daha Fazla Bilgi Edinin",
    "bl_read_more": "Devamını Oku",
    "bl_read_time": "Okuma Süresi",
    "bl_dir_title": "Havaalanı Transferi {city} için",
    "bl_dir_sub": "İsviçre'deki {n} yer hakkında – her birinin kendi rehberi var. Hedefinizi arayın.",
    "bl_search_ph": "Yer arayın, örn. Bern, Interlaken…",
    "bl_no_city": "Hiçbir yer bulunamadı.",
    "ci_eyebrow": "Destinasyonlar",
    "ci_title": "İsviçre Genelinde Transferler",
    "ci_sub": "Her havaalanından her şehre ve dağ köyüne. Destinasyonunuzu seçin veya doğrudan rezervasyon yapın.",
    "ci_popular": "Popüler Yerler",
    "pp_eyebrow": "Fiyatlar",
    "pp_title": "Şeffaf Sabit Fiyatlar",
    "pp_sub": "Her yolculuk için sabit bir fiyat: araç sınıfı başına bir temel fiyat artı kilometre fiyatı. Örnek Ekonomi: CHF 70'den itibaren, ardından CHF 2.20/km. Gizli ücret yok.",
    "pp_f1_t": "Sabit Fiyat Garantisi",
    "pp_f1_d": "Rezervasyon sırasında fiyat sabitlenir.",
    "pp_f2_t": "Uçuş Takibi",
    "pp_f2_d": "Gecikme durumunda ücretsiz bekleme süresi.",
    "pp_f3_t": "Dahil",
    "pp_f3_d": "Vergiler, otoyol ücretleri & karşılama dahil.",
    "pp_classes": "Araç Sınıflarımız & Fiyatlarımız",
    "pp_book": "Rezervasyon Yap",
    "pp_dir_title": "Hedefe Göre Fiyatlar",
    "pp_dir_sub": "İsviçre ve komşu ülkelerde {n} yer. Sabit fiyat rehberi için hedefinizi seçin.",
    "pp_from": "den",
    "ct_eyebrow": "İletişim",
    "ct_title": "Size Yardımcı Olmak İçin Buradayız",
    "ct_sub": "Yolculuğunuz veya özel talepleriniz hakkında sorularınız mı var? Bize 7/24 ulaşın — telefon, WhatsApp veya e-posta ile.",
    "ct_phone": "Telefon",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "E-posta",
    "ct_address": "Adres",
    "ct_name": "İsim",
    "ct_message": "Mesaj",
    "ct_send": "Mesaj Gönder",
    "ct_required": "Lütfen tüm zorunlu alanları doldurun",
    "ct_sent": "Mesaj gönderildi",
    "ct_sent_d": "En kısa sürede dönüş yapacağız.",
    "ct_fail": "Mesaj gönderilemedi.",
    "ba_back": "Bloga Dön",
    "ba_transfer_to": "{city} havaalanı transferi",
    "ba_guide_creating": "{city} için rehber oluşturuluyor…",
    "ba_guide_creating_note": "Bu, ilk çağrıda bir dakikaya kadar sürebilir.",
    "ba_book_now_transfer": "Şimdi {city} için transferinizi rezervasyon yapın.",
    "ba_ready_generic": "Transferiniz için hazır mı?",
    "ba_not_found": "Öğe bulunamadı",
    "ba_to_blog": "Bloga Git",
    "ba_more_articles": "Diğer Makaleler",
    "hero_eyebrow": "Zürich Havaalanı · İsviçre Şoför Hizmeti",
    "hero_book_wa": "WhatsApp ile Rezervasyon Yap",
    "hero_trust_sub": "Zürich Havaalanı'ndaki yolcular arasında popüler",
    "ft_desc": "İsviçre genelinde premium şoför ve havaalanı transfer hizmeti.",
    "ft_services": "Hizmetler",
    "ft_company": "Şirket",
    "ft_popular": "Popüler Yerler",
    "ft_svc_flughafen": "Havaalanı Transferi",
    "ft_svc_city": "Şehirden Şehire",
    "ft_svc_hourly": "Saatlik Rezervasyon",
    "ft_svc_biz": "İş Seyahatleri",
    "ft_fleet": "Filo",
    "ft_dest": "Seyahat Noktaları",
    "ft_blog": "Blog",
    "ft_contact": "İletişim",
    "ft_rights": "Tüm hakları saklıdır.",
    "ft_legal": "Gizlilik · Şartlar · Yasal Uyarı",
    "dest_learn_more": "Daha Fazla Bilgi Edinin"
  },
  "ru": {
    "cp_kw_label": "Трансфер в аэропорт",
    "cp_eyebrow": "Трансфер в аэропорт Zürich",
    "cp_taxi_limo": "Такси и лимузины",
    "cp_b1": "Фиксированная цена",
    "cp_b2": "Отслеживание рейсов 24/7",
    "cp_b3": "Лицензированные водители",
    "cp_calc_price": "Рассчитать цену",
    "cp_f1_t": "Фиксированные цены",
    "cp_f1_d": "Ваша цена фиксируется перед поездкой — без сюрпризов.",
    "cp_f2_t": "Всегда вовремя",
    "cp_f2_d": "Мы следим за вашим рейсом и подстраиваемся.",
    "cp_f3_t": "Безопасно и лицензировано",
    "cp_f3_d": "Обученные швейцарские шоферы, ухоженные автомобили.",
    "cp_vehicles_for": "Транспортные средства для {city}",
    "cp_seats": "Сиденья",
    "cp_guide_loading": "Загрузка подробного путеводителя по {city}…",
    "cp_guide_na": "Путеводитель временно недоступен. Забронируйте сейчас ваш трансфер в {city}.",
    "cp_more_dest": "Другие направления",
    "cp_all_places": "Все места",
    "cp_seo_title": "Трансфер в аэропорт и такси {city}",
    "cp_seo_desc": "Премиум трансфер в аэропорт, такси и услуги шофера в {city}. Фиксированные цены от аэропорта Zürich (ZRH), профессиональные водители и отслеживание рейсов.",
    "cp_prices_for": "Цены на трансфер в аэропорт в {city}",
    "cp_prices_note": "Фиксированные цены за класс автомобиля (ориентировочно от аэропорта Zürich, включая налоги).",
    "cp_ready_transfer": "Готовы к вашему трансферу в {city}?",
    "cp_fixed_sec": "Фиксированная цена за секунды — без регистрации.",
    "cp_book_now": "Забронировать сейчас",
    "bp_step_route": "Маршрут",
    "bp_step_vehicle": "Транспортное средство",
    "bp_step_details": "Детали",
    "bp_step_confirm": "Подтверждение",
    "bp_title": "Забронировать трансфер",
    "bp_subtitle": "Фиксированная цена за секунды — профессиональные шоферы по всей Швейцарии.",
    "bp_pickup": "Адрес забирания",
    "bp_pickup_ph": "Адрес, аэропорт, отель…",
    "bp_dropoff": "Адрес назначения",
    "bp_dropoff_ph": "Адрес назначения…",
    "bp_duration": "Продолжительность",
    "bp_hours_unit": "{n} часов",
    "bp_date": "Дата",
    "bp_date_ph": "Выберите дату",
    "bp_time": "Время",
    "bp_time_ph": "Время",
    "bp_see_prices": "Посмотреть цены",
    "bp_copy_share": "Скопировать и поделиться ссылкой",
    "bp_share_wa": "Поделиться по WhatsApp",
    "bp_copy_link": "Скопировать ссылку",
    "bp_link_copied": "Ссылка скопирована",
    "bp_link_copied_d": "Маршрут, дата и время сохранены в ссылке.",
    "bp_copy_fail": "Не удалось скопировать",
    "bp_fill_all": "Пожалуйста, заполните все поля",
    "bp_fill_all_d": "Необходимы адрес, дата и время.",
    "bp_error": "Ошибка",
    "bp_route_error": "Маршрут не удалось рассчитать.",
    "bp_fill_contact": "Пожалуйста, заполните контактные данные",
    "bp_booking_failed": "Не удалось забронировать.",
    "bp_your_ride": "Ваша поездка",
    "bp_gratis": "(бесплатно)",
    "bp_total": "Итого",
    "bp_incl": "включая НДС, время ожидания и отслеживание рейсов",
    "bp_fixed": "Фиксированная цена",
    "bp_select_next": "Выбрать и продолжить",
    "bp_back": "Назад",
    "bp_passenger_data": "Данные пассажира",
    "bp_passengers": "Пассажиры",
    "bp_luggage": "Багаж",
    "bp_childseats": "Детские кресла",
    "bp_childseats_note": "1. кресло бесплатно · каждое следующее CHF 10",
    "bp_child": "Ребенок",
    "bp_seat_baby": "Детское кресло · 0–1 год",
    "bp_seat_child": "Детское кресло · 1–6 лет",
    "bp_seat_boost": "Увеличение · 6–12 лет",
    "bp_free": "бесплатно",
    "bp_first_name": "Имя",
    "bp_last_name": "Фамилия",
    "bp_email": "Электронная почта",
    "bp_phone": "Телефон",
    "bp_flight_opt": "Номер рейса (необязательно)",
    "bp_notes_opt": "Примечания (необязательно)",
    "bp_payment": "Способ оплаты",
    "bp_card": "Кредитная карта",
    "bp_card_sub": "Оплатить онлайн",
    "bp_cash": "Наличный расчет",
    "bp_cash_sub": "В автомобиле",
    "bp_secure_card": "Безопасная онлайн-оплата кредитной картой (SumUp).",
    "bp_secure_cash": "Ваш запрос будет проверен и подтвержден по электронной почте.",
    "bp_pay_now": "Оплатить онлайн сейчас",
    "bp_send_request": "Отправить запрос",
    "bp_received": "Запрос получен!",
    "bp_received_1": "Ваш запрос на бронирование",
    "bp_received_2": "был отправлен. Мы проверяем доступность и немедленно отправим вам подтверждение по электронной почте.",
    "bp_vehicle": "Транспортное средство",
    "bp_price": "Цена",
    "bp_card_conf": "Кредитная карта (ссылка для оплаты будет отправлена по электронной почте)",
    "bp_cash_conf": "Наличный расчет в автомобиле",
    "bp_back_home": "Вернуться на главную страницу",
    "bl_eyebrow": "Блог",
    "bl_title": "Руководства, направления и трансферы",
    "bl_sub": "Полезные руководства по всем нашим услугам и путеводитель по трансферам в более чем 400 мест в Швейцарии.",
    "bl_cat_flughafen": "Трансфер в аэропорт",
    "bl_cat_flughafen_d": "Из & в аэропорт Zürich по фиксированной цене.",
    "bl_cat_city": "Город в город",
    "bl_cat_city_d": "Прямо между швейцарскими городами.",
    "bl_cat_hourly": "Почасовая аренда",
    "bl_cat_hourly_d": "Ваш шофер на целый день.",
    "bl_cat_biz": "Бизнес",
    "bl_cat_biz_d": "Дискретная мобильность для компаний.",
    "bl_learn_more": "Узнать больше",
    "bl_read_more": "Читать далее",
    "bl_read_time": "Время чтения",
    "bl_dir_title": "Трансфер в аэропорт по месту назначения",
    "bl_dir_sub": "Более {n} мест в Швейцарии — каждое с собственным путеводителем. Найдите ваше место назначения.",
    "bl_search_ph": "Искать место, например, Берн, Интерлакен…",
    "bl_no_city": "Место не найдено.",
    "ci_eyebrow": "Направления",
    "ci_title": "Трансферы по всей Швейцарии",
    "ci_sub": "Из любого аэропорта в любой город и горное село. Выберите ваше направление или забронируйте напрямую.",
    "ci_popular": "Популярные места",
    "pp_eyebrow": "Цены",
    "pp_title": "Прозрачные фиксированные цены",
    "pp_sub": "Каждая поездка по фиксированной цене: базовая цена за класс автомобиля плюс цена за километр. Пример Эконом: от CHF 70, затем CHF 2.20/км. Без скрытых расходов.",
    "pp_f1_t": "Гарантированная фиксированная цена",
    "pp_f1_d": "Цена фиксируется при бронировании.",
    "pp_f2_t": "Отслеживание рейсов",
    "pp_f2_d": "Бесплатное время ожидания при задержке.",
    "pp_f3_t": "Включает",
    "pp_f3_d": "Налоги, сборы и встреча включены.",
    "pp_classes": "Наши классы автомобилей и цены",
    "pp_book": "Забронировать",
    "pp_dir_title": "Цены по местоположению назначения",
    "pp_dir_sub": "Более {n} мест в Швейцарии и соседних странах. Выберите ваше место назначения для путеводителя по фиксированным ценам.",
    "pp_from": "от",
    "ct_eyebrow": "Контакты",
    "ct_title": "Мы всегда готовы помочь",
    "ct_sub": "Есть вопросы о вашей поездке или особые пожелания? Свяжитесь с нами круглосуточно — по телефону, через WhatsApp или по электронной почте.",
    "ct_phone": "Телефон",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "Электронная почта",
    "ct_address": "Адрес",
    "ct_name": "Имя",
    "ct_message": "Сообщение",
    "ct_send": "Отправить сообщение",
    "ct_required": "Пожалуйста, заполните все обязательные поля",
    "ct_sent": "Сообщение отправлено",
    "ct_sent_d": "Мы свяжемся с вами как можно скорее.",
    "ct_fail": "Не удалось отправить сообщение.",
    "ba_back": "Вернуться в блог",
    "ba_transfer_to": "Трансфер в аэропорт в {city}",
    "ba_guide_creating": "Создание путеводителя для {city}…",
    "ba_guide_creating_note": "Это может занять до минуты при первом обращении.",
    "ba_book_now_transfer": "Забронируйте сейчас свой трансфер в {city}.",
    "ba_ready_generic": "Готовы к вашему трансферу?",
    "ba_not_found": "Статья не найдена",
    "ba_to_blog": "В блог",
    "ba_more_articles": "Другие статьи",
    "hero_eyebrow": "Аэропорт Zürich · Швейцарская служба шоферов",
    "hero_book_wa": "Забронировать через WhatsApp",
    "hero_trust_sub": "Популярно среди путешественников в аэропорту Zürich",
    "ft_desc": "Премиум служба шоферов и трансферов в аэропорту по всей Швейцарии.",
    "ft_services": "Услуги",
    "ft_company": "Компания",
    "ft_popular": "Популярные места",
    "ft_svc_flughafen": "Трансфер в аэропорт",
    "ft_svc_city": "Город в город",
    "ft_svc_hourly": "Почасовая аренда",
    "ft_svc_biz": "Деловые поездки",
    "ft_fleet": "Наш флот",
    "ft_dest": "Направления",
    "ft_blog": "Блог",
    "ft_contact": "Контакт",
    "ft_rights": "Все права защищены.",
    "ft_legal": "Конфиденциальность · Условия · Импрессум",
    "dest_learn_more": "Узнать больше"
  },
  "ar": {
    "cp_kw_label": "نقل المطار",
    "cp_eyebrow": "نقل المطار في زوريخ",
    "cp_taxi_limo": "سيارة أجرة وليموزين",
    "cp_b1": "سعر ثابت",
    "cp_b2": "تتبع الرحلات 24/7",
    "cp_b3": "سائقون مرخصون",
    "cp_calc_price": "احسب السعر",
    "cp_f1_t": "أسعار ثابتة",
    "cp_f1_d": "سعر رحلتك ثابت قبل الانطلاق - لا مفاجآت.",
    "cp_f2_t": "دائما في الوقت المحدد",
    "cp_f2_d": "نقوم بمراقبة رحلتك ونتكيف معها.",
    "cp_f3_t": "آمن ومرخص",
    "cp_f3_d": "سائقون سويسريون مدربون، ومركبات مصانة.",
    "cp_vehicles_for": "مركبات لـ {city}",
    "cp_seats": "مقاعد",
    "cp_guide_loading": "جارٍ تحميل دليل شامل لـ {city}…",
    "cp_guide_na": "الدليل غير متوفر حاليا. احجز انتقالك الآن إلى {city}.",
    "cp_more_dest": "وجهات إضافية",
    "cp_all_places": "جميع الأماكن",
    "cp_seo_title": "نقل المطار وسيارة أجرة {city}",
    "cp_seo_desc": "نقل المطار الفاخر، سيارة أجرة وخدمة سائق في {city}. أسعار ثابتة من مطار زوريخ (ZRH)، سائقون محترفون وتتبّع الرحلات على مدار الساعة.",
    "cp_prices_for": "أسعار نقل المطار إلى {city}",
    "cp_prices_note": "أسعار ثابتة لكل فئة مركبة (أسعار تقريبية من مطار زوريخ، شامل الضرائب).",
    "cp_ready_transfer": "هل أنت مستعد لانتقالك إلى {city}؟",
    "cp_fixed_sec": "سعر ثابت في ثوانٍ – بدون الحاجة لحساب.",
    "cp_book_now": "احجز الآن",
    "bp_step_route": "المسار",
    "bp_step_vehicle": "المركبة",
    "bp_step_details": "التفاصيل",
    "bp_step_confirm": "تأكيد",
    "bp_title": "احجز النقل",
    "bp_subtitle": "سعر ثابت في ثوانٍ - سائقون محترفون في جميع أنحاء سويسرا.",
    "bp_pickup": "عنوان الاستلام",
    "bp_pickup_ph": "العنوان، المطار، الفندق…",
    "bp_dropoff": "عنوان التسليم",
    "bp_dropoff_ph": "عنوان التسليم…",
    "bp_duration": "مدة",
    "bp_hours_unit": "{n} ساعات",
    "bp_date": "التاريخ",
    "bp_date_ph": "اختر التاريخ",
    "bp_time": "الوقت",
    "bp_time_ph": "الساعة",
    "bp_see_prices": "عرض الأسعار",
    "bp_copy_share": "نسخ ومشاركة الرابط",
    "bp_share_wa": "مشاركة عبر WhatsApp",
    "bp_copy_link": "نسخ الرابط",
    "bp_link_copied": "تم نسخ الرابط",
    "bp_link_copied_d": "المسار، التاريخ والساعة محفوظة في الرابط.",
    "bp_copy_fail": "فشل النسخ",
    "bp_fill_all": "يرجى ملء جميع الحقول",
    "bp_fill_all_d": "العنوان، التاريخ والساعة مطلوبة.",
    "bp_error": "خطأ",
    "bp_route_error": "تعذر حساب المسار.",
    "bp_fill_contact": "يرجى ملء معلومات الاتصال",
    "bp_booking_failed": "فشلت عملية الحجز.",
    "bp_your_ride": "رحلتك",
    "bp_gratis": "(مجاني)",
    "bp_total": "الإجمالي",
    "bp_incl": "شامل ضريبة القيمة المضافة، وقت الانتظار وتتبّع الرحلات",
    "bp_fixed": "سعر ثابت",
    "bp_select_next": "اختر وواصل",
    "bp_back": "عودة",
    "bp_passenger_data": "بيانات الراكب",
    "bp_passengers": "الركاب",
    "bp_luggage": "الأمتعة",
    "bp_childseats": "مقاعد الأطفال",
    "bp_childseats_note": "1. مقعد مجاني · كل مقعد إضافي CHF 10",
    "bp_child": "طفل",
    "bp_seat_baby": "مقعد للأطفال · 0-1 سنة",
    "bp_seat_child": "مقعد للأطفال · 1-6 سنوات",
    "bp_seat_boost": "مقعد مرتفع · 6-12 سنة",
    "bp_free": "مجاني",
    "bp_first_name": "الاسم الأول",
    "bp_last_name": "اسم العائلة",
    "bp_email": "البريد الإلكتروني",
    "bp_phone": "الهاتف",
    "bp_flight_opt": "رقم الرحلة (اختياري)",
    "bp_notes_opt": "ملاحظات (اختياري)",
    "bp_payment": "طريقة الدفع",
    "bp_card": "بطاقة ائتمانية",
    "bp_card_sub": "الدفع عبر الإنترنت",
    "bp_cash": "دفع نقدي",
    "bp_cash_sub": "في المركبة",
    "bp_secure_card": "دفع آمن عبر الإنترنت بواسطة بطاقة ائتمان (SumUp).",
    "bp_secure_cash": "سيتم مراجعة طلبك وتأكيده عبر البريد الإلكتروني.",
    "bp_pay_now": "ادفع الآن عبر الإنترنت",
    "bp_send_request": "إرسال الطلب",
    "bp_received": "تم استلام الطلب!",
    "bp_received_1": "طلب الحجز الخاص بك",
    "bp_received_2": "تم توصيله. سنراجع التوافر ونرسل لك تأكيدًا عبر البريد الإلكتروني فورًا.",
    "bp_vehicle": "المركبة",
    "bp_price": "السعر",
    "bp_card_conf": "بطاقة ائتمان (رابط الدفع سيتبع عبر البريد الإلكتروني)",
    "bp_cash_conf": "دفع نقدي في المركبة",
    "bp_back_home": "عودة إلى الصفحة الرئيسية",
    "bl_eyebrow": "مدونة",
    "bl_title": "أدلة، وجهات ونقل",
    "bl_sub": "أدلة عملية لجميع خدماتنا ودليل نقل المطار لأكثر من 400 مكان في سويسرا.",
    "bl_cat_flughafen": "نقل المطار",
    "bl_cat_flughafen_d": "من وإلى مطار زوريخ بسعر ثابت.",
    "bl_cat_city": "مدينة إلى مدينة",
    "bl_cat_city_d": "مباشرة بين المدن السويسرية.",
    "bl_cat_hourly": "حجز بالساعة",
    "bl_cat_hourly_d": "سائقك طوال اليوم.",
    "bl_cat_biz": "رحلات عمل",
    "bl_cat_biz_d": "تنقل سري للشركات.",
    "bl_learn_more": "اعرف المزيد",
    "bl_read_more": "اقرأ المزيد",
    "bl_read_time": "وقت القراءة",
    "bl_dir_title": "نقل المطار إلى الموقع",
    "bl_dir_sub": "أكثر من {n} موقعًا في سويسرا - كل منها مع دليل خاص به. ابحث عن وجهتك.",
    "bl_search_ph": "ابحث عن موقع، مثلاً: برن، إنترلاكن…",
    "bl_no_city": "لم يتم العثور على موقع.",
    "ci_eyebrow": "وجهات",
    "ci_title": "نقل في جميع أنحاء سويسرا",
    "ci_sub": "من أي مطار إلى أي مدينة وأي قرية جبلية. اختر وجهتك أو احجز مباشرة.",
    "ci_popular": "أشهر الأماكن",
    "pp_eyebrow": "الأسعار",
    "pp_title": "أسعار ثابتة شفافة",
    "pp_sub": "كل رحلة بسعر ثابت: سعر أساسي لكل فئة مركبة بالإضافة إلى سعر بالمتر. مثال اقتصاد: من CHF 70، ثم CHF 2.20/km. لا تكاليف مخفية.",
    "pp_f1_t": "سعر ثابت مضمون",
    "pp_f1_d": "السعر ثابت عند الحجز.",
    "pp_f2_t": "تتبع الرحلات",
    "pp_f2_d": "وقت انتظار مجاني في حالة التأخير.",
    "pp_f3_t": "شامل",
    "pp_f3_d": "الضرائب، الرسوم & استقبال شامل.",
    "pp_classes": "فئات مركباتنا والأسعار",
    "pp_book": "احجز",
    "pp_dir_title": "أسعار حسب الوجهة",
    "pp_dir_sub": "أكثر من {n} موقع في سويسرا والدول المجاورة. اختر وجهتك لدليل سعر ثابت.",
    "pp_from": "من",
    "ct_eyebrow": "اتصال",
    "ct_title": "نحن هنا من أجلك",
    "ct_sub": "لديك استفسارات حول رحلتك أو طلبات خاصة؟ اتصل بنا على مدار الساعة - عبر الهاتف، WhatsApp أو البريد الإلكتروني.",
    "ct_phone": "الهاتف",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "البريد الإلكتروني",
    "ct_address": "العنوان",
    "ct_name": "الاسم",
    "ct_message": "رسالة",
    "ct_send": "إرسال الرسالة",
    "ct_required": "يرجى ملء جميع الحقول المطلوبة",
    "ct_sent": "تم إرسال الرسالة",
    "ct_sent_d": "سنتواصل معك في أسرع وقت ممكن.",
    "ct_fail": "تعذر إرسال الرسالة.",
    "ba_back": "عودة إلى المدونة",
    "ba_transfer_to": "نقل المطار إلى {city}",
    "ba_guide_creating": "جارٍ إنشاء دليل لـ {city}…",
    "ba_guide_creating_note": "قد يستغرق هذا عند الزيارة الأولى حتى دقيقة واحدة.",
    "ba_book_now_transfer": "احجز الآن انتقالك إلى {city}.",
    "ba_ready_generic": "هل أنت مستعد لنقلك؟",
    "ba_not_found": "لم يتم العثور على العنصر",
    "ba_to_blog": "إلى المدونة",
    "ba_more_articles": "مقالات إضافية",
    "hero_eyebrow": "مطار زوريخ · خدمة سائق سويسري",
    "hero_book_wa": "احجز عبر WhatsApp",
    "hero_trust_sub": "شائع بين المسافرين في مطار زوريخ",
    "ft_desc": "خدمة نقل وchauffeur premium في جميع أنحاء سويسرا.",
    "ft_services": "الخدمات",
    "ft_company": "الشركة",
    "ft_popular": "أشهر الأماكن",
    "ft_svc_flughafen": "نقل المطار",
    "ft_svc_city": "مدينة إلى مدينة",
    "ft_svc_hourly": "حجز بالساعة",
    "ft_svc_biz": "رحلات الأعمال",
    "ft_fleet": "أسطولنا",
    "ft_dest": "وجهات السفر",
    "ft_blog": "مدونة",
    "ft_contact": "اتصل",
    "ft_rights": "جميع الحقوق محفوظة.",
    "ft_legal": "سياسة الخصوصية · الشروط والأحكام · معلومات قانونية",
    "dest_learn_more": "اعرف المزيد"
  },
  "fa": {
    "cp_kw_label": "انتقال فرودگاهی",
    "cp_eyebrow": "انتقال فرودگاهی زوریخ",
    "cp_taxi_limo": "تاکسی و لیموزین",
    "cp_b1": "قیمت ثابت",
    "cp_b2": "پیگیری پرواز 24/7",
    "cp_b3": "رانندگان مجاز",
    "cp_calc_price": "محاسبه قیمت",
    "cp_f1_t": "قیمت‌های ثابت",
    "cp_f1_d": "قیمت شما قبل از سفر مشخص است – بدون شگفتی.",
    "cp_f2_t": "همیشه به موقع",
    "cp_f2_d": "پرواز شما را زیر نظر داریم و با آن تطبیق می‌دهیم.",
    "cp_f3_t": "ایمن و مجاز",
    "cp_f3_d": "رانندگان آموزش‌دیده سوئیسی، خودروهای نگهداری شده.",
    "cp_vehicles_for": "خودروها برای {city}",
    "cp_seats": "صندلی‌ها",
    "cp_guide_loading": "راهنمای جامع برای {city} در حال بارگذاری…",
    "cp_guide_na": "راهنما در حال حاضر در دسترس نیست. اکنون انتقال خود را به {city} رزرو کنید.",
    "cp_more_dest": "مقصدهای بیشتر",
    "cp_all_places": "همه مکان‌ها",
    "cp_seo_title": "انتقال فرودگاهی & تاکسی {city}",
    "cp_seo_desc": "انتقال فرودگاهی پریمیوم، تاکسی و خدمات راننده در {city}. قیمت‌های ثابت از فرودگاه زوریخ (ZRH)، رانندگان حرفه‌ای و پیگیری پرواز به صورت 24 ساعته.",
    "cp_prices_for": "قیمت‌ها برای انتقال فرودگاهی به {city}",
    "cp_prices_note": "قیمت‌های ثابت بر اساس کلاس خودرو (نقطه شروع از فرودگاه زوریخ، شامل مالیات).",
    "cp_ready_transfer": "آماده برای انتقال به {city} هستید؟",
    "cp_fixed_sec": "قیمت ثابت در چند ثانیه – بدون نیاز به حساب.",
    "cp_book_now": "اکنون رزرو کنید",
    "bp_step_route": "مسیر",
    "bp_step_vehicle": "خودرو",
    "bp_step_details": "جزئیات",
    "bp_step_confirm": "تأیید",
    "bp_title": "رزرو انتقال",
    "bp_subtitle": "قیمت ثابت در چند ثانیه — رانندگان حرفه‌ای در سراسر سوئیس.",
    "bp_pickup": "آدرس برداشت",
    "bp_pickup_ph": "آدرس، فرودگاه، هتل…",
    "bp_dropoff": "آدرس مقصد",
    "bp_dropoff_ph": "آدرس مقصد…",
    "bp_duration": "مدت زمان",
    "bp_hours_unit": "{n} ساعت",
    "bp_date": "تاریخ",
    "bp_date_ph": "تاریخ را انتخاب کنید",
    "bp_time": "زمان",
    "bp_time_ph": "زمان",
    "bp_see_prices": "مشاهده قیمت‌ها",
    "bp_copy_share": "کپی لینک و اشتراک‌گذاری",
    "bp_share_wa": "از طریق WhatsApp اشتراک‌گذاری کنید",
    "bp_copy_link": "کپی لینک",
    "bp_link_copied": "لینک کپی شد",
    "bp_link_copied_d": "مسیر، تاریخ و زمان در لینک ذخیره شده است.",
    "bp_copy_fail": "کپی کردن ناموفق بود",
    "bp_fill_all": "لطفاً تمام فیلدها را پر کنید",
    "bp_fill_all_d": "آدرس، تاریخ و زمان نیاز است.",
    "bp_error": "خطا",
    "bp_route_error": "مسیر نتوانست محاسبه شود.",
    "bp_fill_contact": "لطفاً اطلاعات تماس را پر کنید",
    "bp_booking_failed": "رزرو ناموفق بود.",
    "bp_your_ride": "سفر شما",
    "bp_gratis": "(رایگان)",
    "bp_total": "مجموع",
    "bp_incl": "شامل مالیات، زمان انتظار و پیگیری پرواز",
    "bp_fixed": "قیمت ثابت",
    "bp_select_next": "انتخاب و ادامه",
    "bp_back": "بازگشت",
    "bp_passenger_data": "اطلاعات مسافر",
    "bp_passengers": "مسافران",
    "bp_luggage": "چمدان",
    "bp_childseats": "صندلی‌های کودک",
    "bp_childseats_note": "1. صندلی رایگان · هر صندلی اضافه CHF 10",
    "bp_child": "کودک",
    "bp_seat_baby": "صندلی نوزاد · 0–1 سال",
    "bp_seat_child": "صندلی کودک · 1–6 سال",
    "bp_seat_boost": "صندلی بلند · 6–12 سال",
    "bp_free": "رایگان",
    "bp_first_name": "نام",
    "bp_last_name": "نام خانوادگی",
    "bp_email": "ایمیل",
    "bp_phone": "تلفن",
    "bp_flight_opt": "شماره پرواز (اختیاری)",
    "bp_notes_opt": "یادداشت‌ها (اختیاری)",
    "bp_payment": "نوع پرداخت",
    "bp_card": "کارت اعتباری",
    "bp_card_sub": "پرداخت آنلاین",
    "bp_cash": "پرداخت نقدی",
    "bp_cash_sub": "در خودرو",
    "bp_secure_card": "پرداخت آنلاین مطمئن با کارت اعتباری (SumUp).",
    "bp_secure_cash": "درخواست شما بررسی شده و از طریق ایمیل تأیید می‌شود.",
    "bp_pay_now": "حالا آنلاین پرداخت کنید",
    "bp_send_request": "ارسال درخواست",
    "bp_received": "درخواست دریافت شد!",
    "bp_received_1": "درخواست رزرو شما",
    "bp_received_2": "ارسال شد. ما در دسترس بودن را بررسی می‌کنیم و به سرعت یک تأییدیه از طریق ایمیل برای شما ارسال می‌کنیم.",
    "bp_vehicle": "خودرو",
    "bp_price": "قیمت",
    "bp_card_conf": "کارت اعتباری (لینک پرداخت از طریق ایمیل ارسال می‌شود)",
    "bp_cash_conf": "پرداخت نقدی در خودرو",
    "bp_back_home": "بازگشت به صفحه اصلی",
    "bl_eyebrow": "وبلاگ",
    "bl_title": "راهنما، مقاصد و انتقال‌ها",
    "bl_sub": "راهنماهای مفید درباره تمامی خدمات ما و یک راهنمای انتقال فرودگاهی برای بیش از 400 نقطه در سوئیس.",
    "bl_cat_flughafen": "انتقال فرودگاهی",
    "bl_cat_flughafen_d": "از و به فرودگاه زوریخ با قیمت ثابت.",
    "bl_cat_city": "شهر به شهر",
    "bl_cat_city_d": "مستقیم بین شهرهای سوئیس.",
    "bl_cat_hourly": "ساعت‌زنی",
    "bl_cat_hourly_d": "راننده شما برای یک روز کامل.",
    "bl_cat_biz": "کسب و کار",
    "bl_cat_biz_d": "تحرک نامحسوس برای شرکت‌ها.",
    "bl_learn_more": "بیشتر بدانید",
    "bl_read_more": "ادامه مطلب",
    "bl_read_time": "زمان مطالعه",
    "bl_dir_title": "انتقال فرودگاهی به مقصد",
    "bl_dir_sub": "بیش از {n} نقطه در سوئیس – هر کدام با راهنمای خود. مقصد خود را جستجو کنید.",
    "bl_search_ph": "جستجوی مکان، مانند برن، اینترلاکن…",
    "bl_no_city": "هیچ مکانی پیدا نشد.",
    "ci_eyebrow": "مقاصد",
    "ci_title": "انتقال‌ها در سراسر سوئیس",
    "ci_sub": "از هر فرودگاهی به هر شهر و هر دهکده کوهستانی. مقصد خود را انتخاب کنید یا مستقیماً رزرو کنید.",
    "ci_popular": "مکان‌های محبوب",
    "pp_eyebrow": "قیمت‌ها",
    "pp_title": "قیمت‌های شفاف ثابت",
    "pp_sub": "هر سفر به یک قیمت ثابت: یک قیمت پایه برای هر کلاس خودرو به علاوه یک قیمت کیلومتر. مثال: اقتصادی: از CHF 70، سپس CHF 2.20/km. هزینه‌های پنهان وجود ندارد.",
    "pp_f1_t": "قیمت ثابت تضمین شده",
    "pp_f1_d": "قیمت هنگام رزرو تعیین شده است.",
    "pp_f2_t": "پیگیری پرواز",
    "pp_f2_d": "زمان انتظار رایگان در صورت تأخیر.",
    "pp_f3_t": "شامل",
    "pp_f3_d": "مالیات، عوارض و ملاقات و خوشامدگویی شامل است.",
    "pp_classes": "کلاس‌های خودرو ما و قیمت‌ها",
    "pp_book": "رزرو",
    "pp_dir_title": "قیمت‌ها به مقصد",
    "pp_dir_sub": "بیش از {n} نقطه در سوئیس و کشورهای همسایه. مقصد خود را برای راهنمای قیمت ثابت انتخاب کنید.",
    "pp_from": "از",
    "ct_eyebrow": "تماس",
    "ct_title": "ما در خدمت شما هستیم",
    "ct_sub": "سؤالاتی در مورد سفر خود یا خواسته‌های خاص؟ شبانه‌روز با ما تماس بگیرید - تلفنی، از طریق WhatsApp یا ایمیل.",
    "ct_phone": "تلفن",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "ایمیل",
    "ct_address": "آدرس",
    "ct_name": "نام",
    "ct_message": "پیام",
    "ct_send": "ارسال پیام",
    "ct_required": "لطفاً تمام فیلدهای الزامی را پر کنید",
    "ct_sent": "پیام ارسال شد",
    "ct_sent_d": "ما به زودی با شما تماس خواهیم گرفت.",
    "ct_fail": "پیام نتوانست ارسال شود.",
    "ba_back": "بازگشت به وبلاگ",
    "ba_transfer_to": "انتقال فرودگاهی به {city}",
    "ba_guide_creating": "راهنمایی برای {city} در حال ایجاد است…",
    "ba_guide_creating_note": "این ممکن است در اولین بار تا یک دقیقه طول بکشد.",
    "ba_book_now_transfer": "اکنون انتقال خود را به {city} رزرو کنید.",
    "ba_ready_generic": "آماده برای انتقال خود هستید؟",
    "ba_not_found": "مقاله پیدا نشد",
    "ba_to_blog": "به وبلاگ",
    "ba_more_articles": "مقالات بیشتر",
    "hero_eyebrow": "فرودگاه زوریخ · خدمات رانندگی سوئیسی",
    "hero_book_wa": "از طریق WhatsApp رزرو کنید",
    "hero_trust_sub": "محبوب در بین مسافران در فرودگاه زوریخ",
    "ft_desc": "خدمات انتقال و راننده پریمیوم در سراسر سوئیس.",
    "ft_services": "خدمات",
    "ft_company": "شرکت",
    "ft_popular": "مکان‌های محبوب",
    "ft_svc_flughafen": "انتقال فرودگاهی",
    "ft_svc_city": "شهر به شهر",
    "ft_svc_hourly": "ساعت‌زنی",
    "ft_svc_biz": "سفرهای تجاری",
    "ft_fleet": "ناوگان ما",
    "ft_dest": "مقصدها",
    "ft_blog": "وبلاگ",
    "ft_contact": "تماس",
    "ft_rights": "کلیه حقوق محفوظ است.",
    "ft_legal": "حریم خصوصی · شرایط و ضوابط · اطلاعات قانونی",
    "dest_learn_more": "بیشتر بدانید"
  },
  "hi": {
    "cp_kw_label": "हवाईअड्डा ट्रांसफर",
    "cp_eyebrow": "हवाईअड्डा ट्रांसफर ज़ürich",
    "cp_taxi_limo": "टैक्सी & लिमोज़ीन",
    "cp_b1": "फिक्स्ड प्राइस",
    "cp_b2": "24/7 फ्लाइट ट्रैकिंग",
    "cp_b3": "लाइसेंसधारी चालक",
    "cp_calc_price": "कीमत.calculate करें",
    "cp_f1_t": "स्थिर मूल्य",
    "cp_f1_d": "आपकी कीमत यात्रा से पहले तय होती है - कोई आश्चर्य नहीं।",
    "cp_f2_t": "हमेशा समय पर",
    "cp_f2_d": "हम आपकी उड़ान की निगरानी करते हैं और हंसते हैं।",
    "cp_f3_t": "सुरक्षित & लाइसेंस प्राप्त",
    "cp_f3_d": "प्रशिक्षित स्विस चालक, अच्छी तरह से बनाए गए वाहन।",
    "cp_vehicles_for": "{city} के लिए वाहन",
    "cp_seats": "सीटें",
    "cp_guide_loading": "{city} के लिए विस्तृत गाइड लोड हो रहा है…",
    "cp_guide_na": "गाइड वर्तमान में उपलब्ध नहीं है। अब अपने ट्रांसफर की बुकिंग करें {city} के लिए।",
    "cp_more_dest": "अन्य स्थान",
    "cp_all_places": "सभी स्थान",
    "cp_seo_title": "हवाईअड्डा ट्रांसफर & टैक्सी {city}",
    "cp_seo_desc": "प्रीमियम हवाईअड्डा ट्रांसफर, टैक्सी & चालक सेवा {city} में। ज़ürich (ZRH) हवाईअड्डे से स्थिर मूल्य, पेशेवर चालक और 24/7 फ्लाइट ट्रैकिंग।",
    "cp_prices_for": "हवाईअड्डा ट्रांसफर के लिए मूल्य {city}",
    "cp_prices_note": "प्रत्येक वाहन श्रेणी के लिए स्थिर मूल्य (ज़ürich हवाईअड्डे से संदर्भ मूल्य, कर सहित)।",
    "cp_ready_transfer": "क्या आप {city} के लिए अपने ट्रांसफर के लिए तैयार हैं?",
    "cp_fixed_sec": "सेकंड में फिक्स्ड प्राइस - बिना खाता के।",
    "cp_book_now": "अब बुक करें",
    "bp_step_route": "मार्ग",
    "bp_step_vehicle": "वाहन",
    "bp_step_details": "विवरण",
    "bp_step_confirm": "पुष्टिकरण",
    "bp_title": "ट्रांसफर बुक करें",
    "bp_subtitle": "सेकंड में फिक्स्ड प्राइस - स्विस में पेशेवर चालक।",
    "bp_pickup": "उठाने का पता",
    "bp_pickup_ph": "पता, हवाईअड्डा, होटल…",
    "bp_dropoff": "गंतव्य का पता",
    "bp_dropoff_ph": "गंतव्य का पता…",
    "bp_duration": "अवधि",
    "bp_hours_unit": "{n} घंटे",
    "bp_date": "दिनांक",
    "bp_date_ph": "दिनांक चुनें",
    "bp_time": "समय",
    "bp_time_ph": "समय",
    "bp_see_prices": "मूल्य देखें",
    "bp_copy_share": "लिंक कॉपी करें & साझा करें",
    "bp_share_wa": "WhatsApp के माध्यम से साझा करें",
    "bp_copy_link": "लिंक कॉपी करें",
    "bp_link_copied": "लिंक कॉपी किया गया",
    "bp_link_copied_d": "मार्ग, दिनांक & समय लिंक में सहेजे गए हैं।",
    "bp_copy_fail": "कॉपी करने में असफल",
    "bp_fill_all": "कृपया सभी फ़ील्ड भरें",
    "bp_fill_all_d": "पता, दिनांक और समय की आवश्यकता है।",
    "bp_error": "त्रुटि",
    "bp_route_error": "मार्ग की गणना नहीं की जा सकी।",
    "bp_fill_contact": "कृपया संपर्क जानकारी भरें",
    "bp_booking_failed": "बुकिंग विफल।",
    "bp_your_ride": "आपकी सवारी",
    "bp_gratis": "(मुफ्त)",
    "bp_total": "कुल",
    "bp_incl": "inkl. VAT, प्रतीक्षा समय & फ्लाइट ट्रैकिंग",
    "bp_fixed": "फिक्स्ड प्राइस",
    "bp_select_next": "चुनें & आगे बढ़ें",
    "bp_back": "वापस",
    "bp_passenger_data": "यात्री डेटा",
    "bp_passengers": "यात्री",
    "bp_luggage": "सामान",
    "bp_childseats": "बच्चों की सीटें",
    "bp_childseats_note": "1. सीट मुफ्त · प्रत्येक अतिरिक्त CHF 10",
    "bp_child": "बच्चा",
    "bp_seat_baby": "बेबी सीट · 0–1 वर्ष",
    "bp_seat_child": "बच्चों की सीट · 1–6 वर्ष",
    "bp_seat_boost": "उच्च सीट · 6–12 वर्ष",
    "bp_free": "मुफ्त",
    "bp_first_name": "पहला नाम",
    "bp_last_name": "अंतिम नाम",
    "bp_email": "ई-मेल",
    "bp_phone": "फोन",
    "bp_flight_opt": "उड़ान संख्या (वैकल्पिक)",
    "bp_notes_opt": "नोट्स (वैकल्पिक)",
    "bp_payment": "भुगतान का प्रकार",
    "bp_card": "क्रेडिट कार्ड",
    "bp_card_sub": "ऑनलाइन भुगतान करें",
    "bp_cash": "नकद भुगतान",
    "bp_cash_sub": "वाहन में",
    "bp_secure_card": "क्रेडिट कार्ड से सुरक्षित ऑनलाइन भुगतान (SumUp)।",
    "bp_secure_cash": "आपका अनुरोध समीक्षा किया जाएगा और ई-मेल से पुष्टि की जाएगी।",
    "bp_pay_now": "अब ऑनलाइन भुगतान करें",
    "bp_send_request": "अनुरोध भेजें",
    "bp_received": "अनुरोध प्राप्त हुआ!",
    "bp_received_1": "आपका बुकिंग अनुरोध",
    "bp_received_2": "भेजा गया। हम उपलब्धता की जांच करेंगे और आपको जल्दी से ई-मेल से पुष्टि भेजेंगे।",
    "bp_vehicle": "वाहन",
    "bp_price": "कीमत",
    "bp_card_conf": "क्रेडिट कार्ड (भुगतान लिंक ई-मेल के माध्यम से भेजा जाएगा)",
    "bp_cash_conf": "वाहन में नकद भुगतान",
    "bp_back_home": "मुख्य पृष्ठ पर वापस जाएँ",
    "bl_eyebrow": "ब्लॉग",
    "bl_title": "गाइड, यात्रा स्थल & ट्रांसफर",
    "bl_sub": "हमारी सभी सेवाओं पर व्यावहारिक गाइड और स्विट्ज़रलैंड के 400 से अधिक स्थानों के लिए हवाईअड्डा ट्रांसफर गाइड।",
    "bl_cat_flughafen": "हवाईअड्डा ट्रांसफर",
    "bl_cat_flughafen_d": "ज़ürich हवाईअड्डे से फिक्स्ड प्राइस पर।",
    "bl_cat_city": "शहर से शहर",
    "bl_cat_city_d": "स्विस शहरों के बीच सीधे।",
    "bl_cat_hourly": "घंटों की बुकिंग",
    "bl_cat_hourly_d": "पूरा दिन आपका चालक।",
    "bl_cat_biz": "व्यापार के लिए",
    "bl_cat_biz_d": "कंपनियों के लिए गुप्त गतिशीलता।",
    "bl_learn_more": "और पढ़ें",
    "bl_read_more": "और पढ़ें",
    "bl_read_time": "पढ़ने का समय",
    "bl_dir_title": "{city} के लिए हवाईअड्डा ट्रांसफर",
    "bl_dir_sub": "स्विट्ज़रलैंड में {n} स्थानों - प्रत्येक के लिए अपना गाइड। अपना गंतव्य खोजें।",
    "bl_search_ph": "स्थान खोजें, जैसे बर्न, इंटरलाकेन…",
    "bl_no_city": "कोई स्थान नहीं मिला।",
    "ci_eyebrow": "गंतव्य",
    "ci_title": "स्विट्ज़रलैंड में ट्रांसफर",
    "ci_sub": "किसी भी हवाईअड्डे से किसी भी शहर और पहाड़ी गांव तक। अपने गंतव्य का चयन करें या सीधे बुक करें।",
    "ci_popular": "लोकप्रिय स्थान",
    "pp_eyebrow": "मूल्य",
    "pp_title": "पारदर्शी फिक्स्ड प्राइस",
    "pp_sub": "प्रत्येक यात्रा के लिए एक फिक्स्ड मूल्य: प्रत्येक वाहन श्रेणी के लिए एक मूल मूल्य और प्रति किलोमीटर मूल्य। उदाहरण इकोनॉमी: CHF 70 से, इसके बाद CHF 2.20/किमी। कोई छिपी हुई लागत नहीं।",
    "pp_f1_t": "फिक्स्ड प्राइस की गारंटी",
    "pp_f1_d": "बुकिंग के समय मूल्य निर्धारित।",
    "pp_f2_t": "फ्लाइट ट्रैकिंग",
    "pp_f2_d": "विलंब होने पर मुफ्त प्रतीक्षा समय।",
    "pp_f3_t": "समावेशी",
    "pp_f3_d": "कर, टोल & मीट-ऑन-ग्रीट शामिल।",
    "pp_classes": "हमारी वाहन श्रेणियाँ & मूल्य",
    "pp_book": "बुक करें",
    "pp_dir_title": "गंतव्य के लिए मूल्य",
    "pp_dir_sub": "स्विट्ज़रलैंड और पड़ोसी देशों के {n} स्थानों के बारे में। स्थिर मूल्य गाइड के लिए अपना गंतव्य चुनें।",
    "pp_from": "से",
    "ct_eyebrow": "संपर्क",
    "ct_title": "हम आपके लिए हैं",
    "ct_sub": "आपकी यात्रा के बारे में कोई प्रश्न या विशेष अनुरोध? हमारी सहायता करें 24/7 - फोन, WhatsApp या ई-मेल।",
    "ct_phone": "फोन",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "ई-मेल",
    "ct_address": "पता",
    "ct_name": "नाम",
    "ct_message": "संदेश",
    "ct_send": "संदेश भेजें",
    "ct_required": "कृपया सभी अनिवार्य क्षेत्रों को भरें",
    "ct_sent": "संदेश भेजा गया",
    "ct_sent_d": "हम जल्द से जल्द आपसे संपर्क करेंगे।",
    "ct_fail": "संदेश नहीं भेजा जा सका।",
    "ba_back": "ब्लॉग पर वापस जाएँ",
    "ba_transfer_to": "{city} के लिए हवाईअड्डा ट्रांसफर",
    "ba_guide_creating": "{city} के लिए गाइड बनाया जा रहा है…",
    "ba_guide_creating_note": "यह पहले अनुरोध पर एक मिनट तक ले सकता है।",
    "ba_book_now_transfer": "अब अपने {city} के लिए ट्रांसफर की बुकिंग करें।",
    "ba_ready_generic": "क्या आप अपने ट्रांसफर के लिए तैयार हैं?",
    "ba_not_found": "आइटम नहीं मिला",
    "ba_to_blog": "ब्लॉग पर जाएं",
    "ba_more_articles": "अधिक लेख",
    "hero_eyebrow": "जूरिच एयरपोर्ट · स्विस चालक सेवा",
    "hero_book_wa": "WhatsApp के माध्यम से बुक करें",
    "hero_trust_sub": "ज़ürich हवाईअड्डे पर यात्रियों के बीच लोकप्रिय",
    "ft_desc": "स्विट्ज़रलैंड में प्रीमियम चालक और हवाईअड्डा ट्रांसफर सेवा।",
    "ft_services": "सेवाएं",
    "ft_company": "कंपनी",
    "ft_popular": "लोकप्रिय स्थान",
    "ft_svc_flughafen": "हवाईअड्डा ट्रांसफर",
    "ft_svc_city": "शहर से शहर",
    "ft_svc_hourly": "घंटों की बुकिंग",
    "ft_svc_biz": "व्यापार यात्रा",
    "ft_fleet": "हमारी बेड़े",
    "ft_dest": "यात्रा स्थल",
    "ft_blog": "ब्लॉग",
    "ft_contact": "संपर्क",
    "ft_rights": "सर्वाधिकार सुरक्षित।",
    "ft_legal": "डेटा सुरक्षा · शर्तें · प्रिंट",
    "dest_learn_more": "और पढ़ें"
  },
  "zh": {
    "cp_kw_label": "机场接送",
    "cp_eyebrow": "苏黎世机场接送",
    "cp_taxi_limo": "出租车与豪华轿车",
    "cp_b1": "固定价格",
    "cp_b2": "24/7 航班追踪",
    "cp_b3": "持证司机",
    "cp_calc_price": "计算价格",
    "cp_f1_t": "固定价格",
    "cp_f1_d": "您的价格在出发前确定——没有意外。",
    "cp_f2_t": "准时抵达",
    "cp_f2_d": "我们会监控您的航班并进行调整。",
    "cp_f3_t": "安全与持证",
    "cp_f3_d": "经过培训的瑞士司机，车辆保养良好。",
    "cp_vehicles_for": "{city}的车辆",
    "cp_seats": "座位",
    "cp_guide_loading": "{city}详细旅行指南加载中…",
    "cp_guide_na": "旅行指南当前不可用。现在预订前往{city}的接送。",
    "cp_more_dest": "更多目的地",
    "cp_all_places": "所有地点",
    "cp_seo_title": "{city}的机场接送与出租车",
    "cp_seo_desc": "在{city}提供优质的机场接送、出租车与司机服务。自苏黎世机场（ZRH）起的固定价格，专业司机及24小时航班追踪。",
    "cp_prices_for": "前往{city}的机场接送价格",
    "cp_prices_note": "每种车辆类别的固定价格（瑞士法郎起，含税）。",
    "cp_ready_transfer": "准备好前往{city}的接送吗？",
    "cp_fixed_sec": "几秒钟内确认固定价格——无需账户。",
    "cp_book_now": "立即预订",
    "bp_step_route": "路线",
    "bp_step_vehicle": "车辆",
    "bp_step_details": "详情",
    "bp_step_confirm": "确认",
    "bp_title": "预订接送",
    "bp_subtitle": "几秒钟内确认固定价格——瑞士全境的专业司机。",
    "bp_pickup": "接送地址",
    "bp_pickup_ph": "地址、机场、酒店等…",
    "bp_dropoff": "目的地地址",
    "bp_dropoff_ph": "目的地地址…",
    "bp_duration": "时长",
    "bp_hours_unit": "{n} 小时",
    "bp_date": "日期",
    "bp_date_ph": "选择日期",
    "bp_time": "时间",
    "bp_time_ph": "时间",
    "bp_see_prices": "查看价格",
    "bp_copy_share": "复制链接并分享",
    "bp_share_wa": "通过WhatsApp分享",
    "bp_copy_link": "复制链接",
    "bp_link_copied": "链接已复制",
    "bp_link_copied_d": "路线、日期和时间已保存在链接中。",
    "bp_copy_fail": "复制失败",
    "bp_fill_all": "请填写所有字段",
    "bp_fill_all_d": "需要地址、日期和时间。",
    "bp_error": "错误",
    "bp_route_error": "无法计算路线。",
    "bp_fill_contact": "请填写联系信息",
    "bp_booking_failed": "预订失败。",
    "bp_your_ride": "您的行程",
    "bp_gratis": "(免费)",
    "bp_total": "总计",
    "bp_incl": "含增值税、等待时间及航班追踪",
    "bp_fixed": "固定价格",
    "bp_select_next": "选择并继续",
    "bp_back": "返回",
    "bp_passenger_data": "乘客数据",
    "bp_passengers": "乘客",
    "bp_luggage": "行李",
    "bp_childseats": "儿童座椅",
    "bp_childseats_note": "1. 第一座椅免费 · 每多一个CHF 10",
    "bp_child": "儿童",
    "bp_seat_baby": "婴儿座椅 · 0–1岁",
    "bp_seat_child": "儿童座椅 · 1–6岁",
    "bp_seat_boost": "儿童增高座椅 · 6–12岁",
    "bp_free": "免费",
    "bp_first_name": "名",
    "bp_last_name": "姓",
    "bp_email": "电子邮件",
    "bp_phone": "电话",
    "bp_flight_opt": "航班号（可选）",
    "bp_notes_opt": "备注（可选）",
    "bp_payment": "支付方式",
    "bp_card": "信用卡",
    "bp_card_sub": "在线支付",
    "bp_cash": "现金支付",
    "bp_cash_sub": "在车上支付",
    "bp_secure_card": "安全的在线信用卡支付（SumUp）。",
    "bp_secure_cash": "您的请求将被审核并通过电子邮件确认。",
    "bp_pay_now": "立即在线支付",
    "bp_send_request": "发送请求",
    "bp_received": "请求已收到！",
    "bp_received_1": "您的预订请求",
    "bp_received_2": "已提交。我们将检查可用性并立即通过电子邮件发送确认。",
    "bp_vehicle": "车辆",
    "bp_price": "价格",
    "bp_card_conf": "信用卡（支付链接将通过电子邮件发送）",
    "bp_cash_conf": "车上现金支付",
    "bp_back_home": "返回首页",
    "bl_eyebrow": "博客",
    "bl_title": "指南、目的地与接送",
    "bl_sub": "关于我们所有服务的实用指南，以及超过400个瑞士目的地的机场接送指南。",
    "bl_cat_flughafen": "机场接送",
    "bl_cat_flughafen_d": "从苏黎世机场及返回的固定价格。",
    "bl_cat_city": "城市间",
    "bl_cat_city_d": "直接在瑞士城市之间。",
    "bl_cat_hourly": "按小时预订",
    "bl_cat_hourly_d": "您整天的司机。",
    "bl_cat_biz": "商务",
    "bl_cat_biz_d": "为企业提供的隐私出行。",
    "bl_learn_more": "了解更多",
    "bl_read_more": "继续阅读",
    "bl_read_time": "阅读时间",
    "bl_dir_title": "前往目的地的机场接送",
    "bl_dir_sub": "关于瑞士的{n}个地点——每个地点都有自己的旅行指南。寻找您的目的地。",
    "bl_search_ph": "搜索地点，例如伯尔尼、因特拉肯…",
    "bl_no_city": "未找到地点。",
    "ci_eyebrow": "目的地",
    "ci_title": "全瑞士的接送",
    "ci_sub": "从每个机场到每个城市和山村。选择您的目的地或直接预订。",
    "ci_popular": "热门地点",
    "pp_eyebrow": "价格",
    "pp_title": "透明固定价格",
    "pp_sub": "每次出行都有固定价格：每种车辆类别一个基础价格加每公里费用。示例经济型：从CHF 70起，其后CHF 2.20/公里。没有隐藏费用。",
    "pp_f1_t": "保证的固定价格",
    "pp_f1_d": "预订时价格即为固定。",
    "pp_f2_t": "航班追踪",
    "pp_f2_d": "延误时免费等待时间。",
    "pp_f3_t": "包含",
    "pp_f3_d": "税费、过路费及接机服务均已包含。",
    "pp_classes": "我们的车辆类别与价格",
    "pp_book": "预订",
    "pp_dir_title": "按目的地的价格",
    "pp_dir_sub": "关于瑞士及邻国的{n}个地点。选择您的目的地，查看固定价格指南。",
    "pp_from": "从",
    "ct_eyebrow": "联系方式",
    "ct_title": "我们为您服务",
    "ct_sub": "关于您的行程或特殊要求的疑问？随时通过电话、WhatsApp或电子邮件与我们联系。",
    "ct_phone": "电话",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "电子邮件",
    "ct_address": "地址",
    "ct_name": "姓名",
    "ct_message": "信息",
    "ct_send": "发送消息",
    "ct_required": "请填写所有必填字段",
    "ct_sent": "消息已发送",
    "ct_sent_d": "我们会尽快回复。",
    "ct_fail": "消息发送失败。",
    "ba_back": "返回博客",
    "ba_transfer_to": "前往{city}的机场接送",
    "ba_guide_creating": "{city}的旅行指南正在创建中…",
    "ba_guide_creating_note": "第一次加载可能需要最多一分钟。",
    "ba_book_now_transfer": "现在预订前往{city}的接送。",
    "ba_ready_generic": "准备好您的接送了吗？",
    "ba_not_found": "未找到文章",
    "ba_to_blog": "到博客",
    "ba_more_articles": "更多文章",
    "hero_eyebrow": "苏黎世机场 · 瑞士司机服务",
    "hero_book_wa": "通过WhatsApp预订",
    "hero_trust_sub": "受到苏黎世机场旅行者的喜爱",
    "ft_desc": "全瑞士优质司机与机场接送服务。",
    "ft_services": "服务",
    "ft_company": "公司",
    "ft_popular": "热门地点",
    "ft_svc_flughafen": "机场接送",
    "ft_svc_city": "城市间",
    "ft_svc_hourly": "按小时预订",
    "ft_svc_biz": "商务出行",
    "ft_fleet": "我们的车队",
    "ft_dest": "目的地",
    "ft_blog": "博客",
    "ft_contact": "联系方式",
    "ft_rights": "保留所有权利。",
    "ft_legal": "隐私政策 · 条款与条件 · 版权信息",
    "dest_learn_more": "了解更多"
  },
  "ko": {
    "cp_kw_label": "공항 픽업",
    "cp_eyebrow": "취리히 공항 픽업",
    "cp_taxi_limo": "택시 & 리무진",
    "cp_b1": "고정 가격",
    "cp_b2": "24/7 비행 추적",
    "cp_b3": "면허가 있는 기사",
    "cp_calc_price": "가격 계산",
    "cp_f1_t": "고정 가격",
    "cp_f1_d": "여행 전에 가격이 확정됩니다 – 놀라움은 없습니다.",
    "cp_f2_t": "항상 정시",
    "cp_f2_d": "비행기를 모니터링하고 조정합니다.",
    "cp_f3_t": "안전 & 면허",
    "cp_f3_d": "훈련된 스위스 운전사, 관리된 차량.",
    "cp_vehicles_for": "{city}를 위한 차량",
    "cp_seats": "좌석",
    "cp_guide_loading": "{city}에 대한 상세 여행 가이드 로딩 중…",
    "cp_guide_na": "여행 가이드를 현재 이용할 수 없습니다. 지금 {city}로의 픽업을 예약하세요.",
    "cp_more_dest": "다른 목적지",
    "cp_all_places": "모든 장소",
    "cp_seo_title": "{city} 공항 픽업 & 택시",
    "cp_seo_desc": "{city}에서 프리미엄 공항 픽업, 택시 및 운전사 서비스. 취리히(ZRH) 공항에서 고정 가격, 전문 운전사 및 24시간 비행 추적.",
    "cp_prices_for": "{city}로의 공항 픽업 가격",
    "cp_prices_note": "차량 유형별 고정 가격(취리히 공항 기준, 세금 포함).",
    "cp_ready_transfer": "{city}로의 픽업 준비 되셨나요?",
    "cp_fixed_sec": "몇 초 만에 고정 가격 – 계좌 없이.",
    "cp_book_now": "지금 예약하기",
    "bp_step_route": "경로",
    "bp_step_vehicle": "차량",
    "bp_step_details": "세부사항",
    "bp_step_confirm": "확인",
    "bp_title": "픽업 예약하기",
    "bp_subtitle": "몇 초 만에 고정 가격 — 스위스 전역의 전문 운전사.",
    "bp_pickup": "픽업 주소",
    "bp_pickup_ph": "주소, 공항, 호텔…",
    "bp_dropoff": "하차 주소",
    "bp_dropoff_ph": "하차 주소…",
    "bp_duration": "소요 시간",
    "bp_hours_unit": "{n} 시간",
    "bp_date": "날짜",
    "bp_date_ph": "날짜 선택",
    "bp_time": "시간",
    "bp_time_ph": "시간",
    "bp_see_prices": "가격 보기",
    "bp_copy_share": "링크 복사 & 공유",
    "bp_share_wa": "WhatsApp으로 공유",
    "bp_copy_link": "링크 복사",
    "bp_link_copied": "링크가 복사되었습니다",
    "bp_link_copied_d": "경로, 날짜 & 시간이 링크에 저장되었습니다.",
    "bp_copy_fail": "복사 실패",
    "bp_fill_all": "모든 필드를 작성해 주세요",
    "bp_fill_all_d": "주소, 날짜 및 시간이 필요합니다.",
    "bp_error": "오류",
    "bp_route_error": "경로를 계산할 수 없습니다.",
    "bp_fill_contact": "연락처 정보를 입력해 주세요",
    "bp_booking_failed": "예약 실패.",
    "bp_your_ride": "귀하의 차량",
    "bp_gratis": "(무료)",
    "bp_total": "총합",
    "bp_incl": "부가세 포함, 대기 시간 & 비행 추적",
    "bp_fixed": "고정 가격",
    "bp_select_next": "선택 & 계속",
    "bp_back": "뒤로",
    "bp_passenger_data": "승객 데이터",
    "bp_passengers": "승객",
    "bp_luggage": "수하물",
    "bp_childseats": "어린이 좌석",
    "bp_childseats_note": "1. 좌석 무료 · 추가 좌석 CHF 10",
    "bp_child": "어린이",
    "bp_seat_baby": "유아용 좌석 · 0–1세",
    "bp_seat_child": "어린이 좌석 · 1–6세",
    "bp_seat_boost": "부스터 시트 · 6–12세",
    "bp_free": "무료",
    "bp_first_name": "이름",
    "bp_last_name": "성",
    "bp_email": "이메일",
    "bp_phone": "전화",
    "bp_flight_opt": "항공편 번호 (선택 사항)",
    "bp_notes_opt": "메모 (선택 사항)",
    "bp_payment": "지불 방법",
    "bp_card": "신용카드",
    "bp_card_sub": "온라인 결제",
    "bp_cash": "현금",
    "bp_cash_sub": "차량 내에서",
    "bp_secure_card": "신용카드(세이프업)로 안전한 온라인 결제.",
    "bp_secure_cash": "요청이 확인되고 이메일로 확인됩니다.",
    "bp_pay_now": "지금 온라인으로 결제하기",
    "bp_send_request": "요청 접수",
    "bp_received": "요청이 접수되었습니다!",
    "bp_received_1": "예약 요청이",
    "bp_received_2": "전달되었습니다. 이용 가능성을 확인하고 즉시 이메일로 확인서를 보내드립니다.",
    "bp_vehicle": "차량",
    "bp_price": "가격",
    "bp_card_conf": "신용카드 (결제 링크는 이메일로 발송됩니다)",
    "bp_cash_conf": "차량 내에서 현금 결제",
    "bp_back_home": "홈으로 돌아가기",
    "bl_eyebrow": "블로그",
    "bl_title": "가이드, 여행지 & 픽업",
    "bl_sub": "우리 서비스에 대한 실용적인 가이드와 스위스 전역 400개 이상의 장소에 대한 공항 픽업 가이드.",
    "bl_cat_flughafen": "공항 픽업",
    "bl_cat_flughafen_d": "취리히 공항에서의 고정 가격.",
    "bl_cat_city": "도시 간 픽업",
    "bl_cat_city_d": "스위스 도시 간 직접 이동.",
    "bl_cat_hourly": "시간제 예약",
    "bl_cat_hourly_d": "하루 종일 운전사.",
    "bl_cat_biz": "비즈니스",
    "bl_cat_biz_d": "기업을 위한 비밀스러운 이동.",
    "bl_learn_more": "더 알아보기",
    "bl_read_more": "더 읽기",
    "bl_read_time": "읽기 시간",
    "bl_dir_title": "{n}개 도시에 대한 공항 픽업",
    "bl_dir_sub": "스위스의 {n}개 장소에 대한 여행 가이드. 목적지를 검색하세요.",
    "bl_search_ph": "장소 검색, 예: 베른, 인터라켄…",
    "bl_no_city": "장소를 찾을 수 없습니다.",
    "ci_eyebrow": "목적지",
    "ci_title": "스위스 전역의 픽업",
    "ci_sub": "모든 공항에서 모든 도시 및 산촌으로. 여러분의 목적지를 선택하거나 직접 예약하세요.",
    "ci_popular": "인기 있는 장소",
    "pp_eyebrow": "가격",
    "pp_title": "투명한 고정 가격",
    "pp_sub": "모든 여행은 고정 가격: 차량 클래스당 기본 요금과 km 요금. 예: 이코노미: CHF 70부터 시작, 그 후 CHF 2.20/km. 숨겨진 비용 없음.",
    "pp_f1_t": "고정 가격 보장",
    "pp_f1_d": "예약 시 가격이 확정됩니다.",
    "pp_f2_t": "비행 추적",
    "pp_f2_d": "지연 시 무료 대기 시간.",
    "pp_f3_t": "포함",
    "pp_f3_d": "세금, 톨게이트 요금 및 미팅 서비스 포함.",
    "pp_classes": "우리의 차량 클래스 & 가격",
    "pp_book": "예약하기",
    "pp_dir_title": "목적지별 가격",
    "pp_dir_sub": "{n}개 스위스 및 인근 나라의 장소. 고정 가격 여행 가이드를 위한 목적지를 선택하세요.",
    "pp_from": "부터",
    "ct_eyebrow": "연락처",
    "ct_title": "우리는 당신을 위해 여기 있습니다",
    "ct_sub": "여행에 대한 질문이나 특별 요청이 있나요? 24시간 내내 연락하세요 — 전화, WhatsApp 또는 이메일로.",
    "ct_phone": "전화",
    "ct_whatsapp": "WhatsApp",
    "ct_email": "이메일",
    "ct_address": "주소",
    "ct_name": "이름",
    "ct_message": "메시지",
    "ct_send": "메시지 보내기",
    "ct_required": "모든 필수 필드를 작성해 주세요",
    "ct_sent": "메시지가 전송되었습니다",
    "ct_sent_d": "가능한 빨리 연락드리겠습니다.",
    "ct_fail": "메시지를 보낼 수 없습니다.",
    "ba_back": "블로그로 돌아가기",
    "ba_transfer_to": "{city}로의 공항 픽업",
    "ba_guide_creating": "{city}에 대한 여행 가이드 생성 중…",
    "ba_guide_creating_note": "첫 호출 시 최대 1분이 소요될 수 있습니다.",
    "ba_book_now_transfer": "{city}로의 픽업을 지금 예약하세요.",
    "ba_ready_generic": "픽업 준비 되셨나요?",
    "ba_not_found": "찾을 수 없습니다",
    "ba_to_blog": "블로그로 가기",
    "ba_more_articles": "더 많은 기사",
    "hero_eyebrow": "취리히 공항 · 스위스 운전 서비스",
    "hero_book_wa": "WhatsApp으로 예약하기",
    "hero_trust_sub": "취리히 공항에서 여행자들에게 인기",
    "ft_desc": "스위스 전역의 프리미엄 운전사 및 공항 픽업 서비스.",
    "ft_services": "서비스",
    "ft_company": "회사",
    "ft_popular": "인기 있는 장소",
    "ft_svc_flughafen": "공항 픽업",
    "ft_svc_city": "도시 간 픽업",
    "ft_svc_hourly": "시간제 예약",
    "ft_svc_biz": "비즈니스 여행",
    "ft_fleet": "우리의 차량",
    "ft_dest": "여행지",
    "ft_blog": "블로그",
    "ft_contact": "연락처",
    "ft_rights": "모든 권리 보유.",
    "ft_legal": "개인정보 보호 · 이용 약관 · 면책 조항",
    "dest_learn_more": "더 알아보기"
  },
  "ckb": {
    "cp_kw_label": "گواستنەوەی فڕۆکەخانە",
    "cp_eyebrow": "گواستنەوەی فڕۆکەخانەی زوریخ",
    "cp_taxi_limo": "تاکسی و لیموزین",
    "cp_b1": "نرخی جێگیر",
    "cp_b2": "شوێنکەوتنی فڕۆکە ٢٤/٧",
    "cp_b3": "شۆفێری مۆڵەتدار",
    "cp_calc_price": "نرخ هەژمار بکە",
    "cp_f1_t": "نرخی جێگیر",
    "cp_f1_d": "نرخەکەت پێش گەشتەکە دیاری دەکرێت – بێ هیچ سەرسوڕمانێک.",
    "cp_f2_t": "هەمیشە لە کاتی خۆیدا",
    "cp_f2_d": "چاودێری فڕۆکەکەت دەکەین و خۆمان بۆی دەگونجێنین.",
    "cp_f3_t": "پارێزراو و مۆڵەتدار",
    "cp_f3_d": "شۆفێری ڕاهێنراوی سویسری، ئۆتۆمبێلی چاکسازکراو.",
    "cp_vehicles_for": "ئۆتۆمبێلەکان بۆ {city}",
    "cp_seats": "شوێنی دانیشتن",
    "cp_guide_loading": "ڕێنمای وردی {city} بار دەکرێت…",
    "cp_guide_na": "ڕێنما لە ئێستادا بەردەست نییە. ئێستا گواستنەوەکەت بۆ {city} حجز بکە.",
    "cp_more_dest": "شوێنی زیاتر",
    "cp_all_places": "هەموو شوێنەکان",
    "cp_seo_title": "گواستنەوەی فڕۆکەخانە و تاکسی {city}",
    "cp_seo_desc": "گواستنەوەی فڕۆکەخانەی پێشکەوتوو، تاکسی و خزمەتگوزاری شۆفێر لە {city}. نرخی جێگیر لە فڕۆکەخانەی زوریخ (ZRH)، شۆفێری پیشەیی و شوێنکەوتنی فڕۆکە بە درێژایی شەوانەڕۆژ.",
    "cp_prices_for": "نرخەکانی گواستنەوەی فڕۆکەخانە بۆ {city}",
    "cp_prices_note": "نرخی جێگیر بۆ هەر پۆلێکی ئۆتۆمبێل (بەنموونە لە فڕۆکەخانەی زوریخ، لەگەڵ باج).",
    "cp_ready_transfer": "ئامادەیت بۆ گواستنەوەکەت بۆ {city}؟",
    "cp_fixed_sec": "نرخی جێگیر لە چەند چرکەیەکدا – بەبێ هەژمار.",
    "cp_book_now": "ئێستا حجز بکە",
    "bp_step_route": "ڕێڕەو",
    "bp_step_vehicle": "ئۆتۆمبێل",
    "bp_step_details": "وردەکاری",
    "bp_step_confirm": "پشتڕاستکردنەوە",
    "bp_title": "گواستنەوە حجز بکە",
    "bp_subtitle": "نرخی جێگیر لە چەند چرکەیەکدا — شۆفێری پیشەیی لە سەرانسەری سویسرا.",
    "bp_pickup": "ناونیشانی وەرگرتن",
    "bp_pickup_ph": "ناونیشان، فڕۆکەخانە، هۆتێل…",
    "bp_dropoff": "ناونیشانی گەیشتن",
    "bp_dropoff_ph": "ناونیشانی مەبەست…",
    "bp_duration": "ماوە",
    "bp_hours_unit": "{n} کاتژمێر",
    "bp_date": "بەروار",
    "bp_date_ph": "بەروار هەڵبژێرە",
    "bp_time": "کات",
    "bp_time_ph": "کات",
    "bp_see_prices": "نرخەکان ببینە",
    "bp_copy_share": "لینک کۆپی و هاوبەش بکە",
    "bp_share_wa": "لە ڕێگەی واتساپ هاوبەش بکە",
    "bp_copy_link": "لینک کۆپی بکە",
    "bp_link_copied": "لینک کۆپی کرا",
    "bp_link_copied_d": "ڕێڕەو، بەروار و کات لە لینکەکەدا پاشەکەوت کراون.",
    "bp_copy_fail": "کۆپیکردن سەرکەوتوو نەبوو",
    "bp_fill_all": "تکایە هەموو خانەکان پڕبکەرەوە",
    "bp_fill_all_d": "ناونیشان، بەروار و کات پێویستن.",
    "bp_error": "هەڵە",
    "bp_route_error": "ڕێڕەو هەژمار نەکرا.",
    "bp_fill_contact": "تکایە زانیاری پەیوەندی پڕبکەرەوە",
    "bp_booking_failed": "حجزکردن سەرکەوتوو نەبوو.",
    "bp_your_ride": "گەشتەکەت",
    "bp_gratis": "(بێبەرامبەر)",
    "bp_total": "کۆی گشتی",
    "bp_incl": "لەگەڵ باج، کاتی چاوەڕوانی و شوێنکەوتنی فڕۆکە",
    "bp_fixed": "نرخی جێگیر",
    "bp_select_next": "هەڵبژێرە و بەردەوام بە",
    "bp_back": "گەڕانەوە",
    "bp_passenger_data": "زانیاری پاسینجەر",
    "bp_save_details": "زانیارییەکانم بۆ جاری داهاتوو پاشەکەوت بکە",
    "bp_passengers": "پاسینجەر",
    "bp_luggage": "جانتا",
    "bp_childseats": "کورسی منداڵان",
    "bp_childseats_note": "کورسی یەکەم بێبەرامبەر · هەر یەکێکی زیادە CHF ١٠",
    "bp_child": "منداڵ",
    "bp_seat_baby": "کورسی ساوا · ٠–١ ساڵ",
    "bp_seat_child": "کورسی منداڵ · ١–٦ ساڵ",
    "bp_seat_boost": "کورسی بەرزکەرەوە · ٦–١٢ ساڵ",
    "bp_free": "بێبەرامبەر",
    "bp_first_name": "ناوی یەکەم",
    "bp_last_name": "ناوی خێزان",
    "bp_email": "ئیمەیڵ",
    "bp_phone": "تەلەفۆن",
    "bp_flight_opt": "ژمارەی فڕۆکە (ئارەزوومەندانە)",
    "bp_notes_opt": "تێبینی (ئارەزوومەندانە)",
    "bp_payment": "شێوازی پارەدان",
    "bp_card": "کارتی بانکی",
    "bp_card_sub": "پارەدانی ئۆنڵاین",
    "bp_cash": "پارەدانی کاش",
    "bp_cash_sub": "ناو ئۆتۆمبێل",
    "bp_secure_card": "پارەدانی ئۆنڵاینی پارێزراو بە کارتی بانکی (SumUp).",
    "bp_secure_cash": "داواکارییەکەت پشکنین دەکرێت و بە ئیمەیڵ پشتڕاست دەکرێتەوە.",
    "bp_pay_now": "ئێستا ئۆنڵاین پارە بدە",
    "bp_send_request": "داواکاری بنێرە",
    "bp_card_details": "زانیاری کارت بنووسە",
    "bp_verifying": "پارەدان پشکنین دەکرێت …",
    "bp_pay_pending": "پارەدان هێشتا تەواو نەبووە. تکایە دووبارە هەوڵ بدەوە.",
    "bp_pay_failed": "پارەدان سەرکەوتوو نەبوو. تکایە دووبارە هەوڵ بدەوە.",
    "bp_received": "داواکاری وەرگیرا!",
    "bp_received_1": "داواکاری حجزەکەت",
    "bp_received_2": "نێردرا. بەردەستبوون پشکنین دەکەین و بەم زووانە پشتڕاستکردنەوەیەکت بۆ بە ئیمەیڵ دەنێرین.",
    "bp_vehicle": "ئۆتۆمبێل",
    "bp_price": "نرخ",
    "bp_card_conf": "کارتی بانکی (لینکی پارەدان بە ئیمەیڵ دەنێردرێت)",
    "bp_cash_conf": "پارەدانی کاش لە ناو ئۆتۆمبێل",
    "bp_back_home": "گەڕانەوە بۆ پەڕەی سەرەکی",
    "bl_eyebrow": "بلۆگ",
    "bl_title": "ڕێنماکان، شوێنەکان و گواستنەوەکان",
    "bl_sub": "ڕێنمای بەکارهاتوو بۆ هەموو خزمەتگوزارییەکانمان و ڕێنمای گواستنەوەی فڕۆکەخانە بۆ زیاتر لە ٤٠٠ شوێن لە سویسرا.",
    "bl_cat_flughafen": "گواستنەوەی فڕۆکەخانە",
    "bl_cat_flughafen_d": "بۆ و لە فڕۆکەخانەی زوریخ بە نرخی جێگیر.",
    "bl_cat_city": "شار بۆ شار",
    "bl_cat_city_d": "ڕاستەوخۆ لە نێوان شارەکانی سویسرا.",
    "bl_cat_hourly": "حجزی کاتژمێری",
    "bl_cat_hourly_d": "شۆفێرەکەت بۆ تەواوی ڕۆژ.",
    "bl_cat_biz": "بازرگانی",
    "bl_cat_biz_d": "گواستنەوەی نهێنیانە بۆ کۆمپانیاکان.",
    "bl_learn_more": "زیاتر بزانە",
    "bl_read_more": "زیاتر بخوێنەرەوە",
    "bl_read_time": "کاتی خوێندنەوە",
    "bl_dir_title": "گواستنەوەی فڕۆکەخانە بۆ شوێن",
    "bl_dir_sub": "زیاتر لە {n} شوێن لە سویسرا – هەر یەکێک ڕێنمای خۆی هەیە. بەدوای شوێنی مەبەستت بگەڕێ.",
    "bl_search_ph": "بەدوای شوێندا بگەڕێ، بۆ نموونە بێرن، ئینتەرلاکن…",
    "bl_no_city": "هیچ شوێنێک نەدۆزرایەوە.",
    "ci_eyebrow": "شوێنەکان",
    "ci_title": "گواستنەوە لە سەرانسەری سویسرا",
    "ci_sub": "لە هەر فڕۆکەخانەیەکەوە بۆ هەر شار و گوندێکی چیایی. شوێنی مەبەستت هەڵبژێرە یان ڕاستەوخۆ حجز بکە.",
    "ci_popular": "شوێنە بەناوبانگەکان",
    "pp_eyebrow": "نرخەکان",
    "pp_title": "نرخی جێگیری ڕوون",
    "pp_sub": "هەر گەشتێک بە نرخێکی جێگیر: نرخێکی بنەڕەتی بۆ هەر پۆلێکی ئۆتۆمبێل لەگەڵ نرخی کیلۆمەتری. نموونەی ئیکۆنۆمی: لە CHF ٧٠ـەوە، پاشان CHF ٢.٢٠/کم. بێ هیچ تێچوونێکی شاراوە.",
    "pp_f1_t": "نرخی جێگیری دڵنیاکراو",
    "pp_f1_d": "نرخ لە کاتی حجزکردندا جێگیر دەکرێت.",
    "pp_f2_t": "شوێنکەوتنی فڕۆکە",
    "pp_f2_d": "کاتی چاوەڕوانی بێبەرامبەر لە کاتی دواکەوتن.",
    "pp_f3_t": "لەخۆگرتوو",
    "pp_f3_d": "باج، پارەی ڕێگا و پێشوازی لەخۆدەگرێت.",
    "pp_classes": "پۆلەکانی ئۆتۆمبێل و نرخەکانمان",
    "pp_book": "حجز بکە",
    "pp_dir_title": "نرخەکان بەپێی شوێن",
    "pp_dir_sub": "زیاتر لە {n} شوێن لە سویسرا و وڵاتانی دراوسێ. شوێنی مەبەستت هەڵبژێرە بۆ ڕێنمای نرخی جێگیر.",
    "pp_from": "لە",
    "ct_eyebrow": "پەیوەندی",
    "ct_title": "ئێمە لێرەین بۆ تۆ",
    "ct_sub": "پرسیارت هەیە دەربارەی گەشتەکەت یان داواکاری تایبەت؟ بە درێژایی شەوانەڕۆژ پەیوەندیمان پێوە بکە — بە تەلەفۆن، واتساپ یان ئیمەیڵ.",
    "ct_phone": "تەلەفۆن",
    "ct_whatsapp": "واتساپ",
    "ct_email": "ئیمەیڵ",
    "ct_address": "ناونیشان",
    "ct_name": "ناو",
    "ct_message": "پەیام",
    "ct_send": "پەیام بنێرە",
    "ct_required": "تکایە هەموو خانە پێویستەکان پڕبکەرەوە",
    "ct_sent": "پەیام نێردرا",
    "ct_sent_d": "بەم زووانە وەڵامت دەدەینەوە.",
    "ct_fail": "پەیام نەنێردرا.",
    "ba_back": "گەڕانەوە بۆ بلۆگ",
    "ba_transfer_to": "گواستنەوەی فڕۆکەخانە بۆ {city}",
    "ba_guide_creating": "ڕێنما بۆ {city} دروست دەکرێت…",
    "ba_guide_creating_note": "ئەمە لە یەکەم سەردانیدا ڕەنگە تا خولەکێک بخایەنێت.",
    "ba_book_now_transfer": "ئێستا گواستنەوەکەت بۆ {city} حجز بکە.",
    "ba_ready_generic": "ئامادەیت بۆ گواستنەوەکەت؟",
    "ba_not_found": "بابەت نەدۆزرایەوە",
    "ba_to_blog": "بۆ بلۆگ",
    "ba_more_articles": "بابەتی زیاتر",
    "hero_eyebrow": "فڕۆکەخانەی زوریخ · خزمەتگوزاری شۆفێری سویسری",
    "hero_book_wa": "لە ڕێگەی واتساپ حجز بکە",
    "hero_trust_sub": "بەناوبانگ لای گەشتیارانی فڕۆکەخانەی زوریخ",
    "ft_desc": "خزمەتگوزاری پێشکەوتووی شۆفێر و گواستنەوەی فڕۆکەخانە لە سەرانسەری سویسرا.",
    "ft_services": "خزمەتگوزارییەکان",
    "ft_company": "کۆمپانیا",
    "ft_popular": "شوێنە بەناوبانگەکان",
    "ft_svc_flughafen": "گواستنەوەی فڕۆکەخانە",
    "ft_svc_city": "شار بۆ شار",
    "ft_svc_hourly": "حجزی کاتژمێری",
    "ft_svc_biz": "گەشتی بازرگانی",
    "ft_fleet": "فلۆتەکەمان",
    "ft_dest": "شوێنەکان",
    "ft_blog": "بلۆگ",
    "ft_contact": "پەیوەندی",
    "ft_rights": "هەموو مافەکان پارێزراون.",
    "ft_legal": "سیاسەتی تایبەتێتی · مەرج و ڕێساکان · ئیمپرینت",
    "dest_learn_more": "زیاتر بزانە"
  }
};
